// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-09T16:36:34.321Z
// Property: The Access (ID: 5697689396183040)
// Collections: 25 amenities, 20 floorplans (live), 28 photos, 84 POIs, 2 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5697689396183040",
  "property_external_id": "4994510",
  "property_zillow_url": "https://www.zillow.com/homedetails/1811-E-Apache-Blvd-Tempe-AZ-85281/2120592388_zpid/",
  "property_apartments_url": "https://www.apartments.com/the-access-tempe-az/ebfzxwq",
  "property_google_business_url": "https://www.google.com/maps/place/Tempe+Metro/@33.4140556,-111.9106553,17z/data=!4m13!1m7!3m6!1s0x872b08f44fd2ea87:0xb3f5a469a89e2caf!2s1811+E+Apache+Blvd,+Tempe,+AZ+85281!3b1!8m2!3d33.4140556!4d-111.9084666!3m4!1s0x872b091eadfe803d:0xef2acac9aaaffcaa!8m2!3d33.4140556!4d-111.9084666",
  "property_linkedin_url": null,
  "property_hubspot_id": "8384504408",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-access",
  "property_name": "The Access",
  "property_website_url": "https://www.liveattheaccess.com/",
  "property_domain": "https://www.liveattheaccess.com/",
  "property_address": "1811 E Apache Blvd",
  "property_full_address": "1811 E Apache Blvd, Tempe, AZ 85281",
  "property_address_1": "1811 E Apache Blvd",
  "property_address_2": null,
  "property_address_city": "Tempe",
  "property_address_state": "AZ",
  "property_address_zip_full": "85281-6088",
  "property_address_zip": "85281",
  "property_address_country": "US",
  "property_address_county": "Maricopa County",
  "property_neighborhood_address": "Apache",
  "property_address_latitude": "33.41418790000001",
  "property_address_longitude": "-111.9086529",
  "property_email": "access@alapts.com",
  "property_phone": "(480) 966-0122",
  "property_call_tracking_phone": "602-557-1208",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Connected Tempe living starts at The Access.</strong> Set along the Apache Boulevard corridor, these studio to three-bedroom apartments pair polished in-home finishes with energizing community spaces and easy access across Tempe.</p>",
  "property_long_description": "<p><strong>Connected Tempe living starts at The Access.</strong> Set along the Apache Boulevard corridor, your apartment puts light rail access, the Tempe Streetcar connection, Arizona State University, and Loop 101 close by—so Downtown Tempe, Mill Avenue, Tempe Town Lake, and the wider East Valley stay easy to reach.</p><p>Choose from studio, one-, two-, and three-bedroom <a href=\"/floor-plans\">floor plans</a> with everyday comforts like in-home washer and dryer sets, stainless steel appliances, granite countertops, tile backsplashes, vinyl hardwood-style flooring, and select homes with walk-in closets, garden tubs, or private balconies.</p><p>Outside your door, The Access brings the energy home with a resort-style pool and spa, rooftop basketball court, fitness center, clubhouse lounge, game room, Starbucks coffee bar, community fireside lounge, summer kitchen, EV charging, package lockers, and a bark park. When you’re ready to get out, explore Apache Boulevard dining, catch a show at ASU Gammage, head toward Four Peaks, or spend the day on the paths around Tempe Town Lake.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-1512-770b-a5ca-2ebbe0f020f8.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas.",
    "public_id": "019d02f1-1512-770b-a5ca-2ebbe0f020f8",
    "storage_key": "property/5697689396183040/019d02f1-1512-770b-a5ca-2ebbe0f020f8.webp",
    "width": 1920,
    "height": 1438
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "408",
  "property_year_built": "2009",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "91.17647058823529",
  "property_admin_fee": "200",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee $75\nAdministrative Fee $150\nNon-Refundable Pet Fee $300 / pet\nMonthly Pet Rent $45 / pet\nApplication Approval Fee Starting At $500",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "45",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $45 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $45 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8887069.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://theaccess.loftliving.com/login",
  "property_apply_now_url": "https://8887069.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-01d6-73ad-8dc8-c4113cf3aa1f.webp",
  "property_primary_logo_media": {
    "alt_text": "The Access logo",
    "public_id": "019d02f1-01d6-73ad-8dc8-c4113cf3aa1f",
    "storage_key": "property/5697689396183040/019d02f1-01d6-73ad-8dc8-c4113cf3aa1f.webp",
    "width": 1920,
    "height": 898
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e7059-1f71-740f-a132-cb32dcab33f8.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Access logo",
    "public_id": "019e7059-1f71-740f-a132-cb32dcab33f8",
    "storage_key": "property/5697689396183040/019e7059-1f71-740f-a132-cb32dcab33f8.webp",
    "width": 1950,
    "height": 961
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e7059-bece-7681-ab38-45ae243bee0a.webp",
  "property_icon_media": {
    "alt_text": "The property's logo, a blue outline of the letter A inside a light blue circle.",
    "public_id": "019e7059-bece-7681-ab38-45ae243bee0a",
    "storage_key": "property/5697689396183040/019e7059-bece-7681-ab38-45ae243bee0a.webp",
    "width": 1050,
    "height": 1050
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e7059-bece-7681-ab38-45ae243bee0a.webp",
  "property_fav_icon_media": {
    "alt_text": "The property's logo, a blue outline of the letter A inside a light blue circle.",
    "public_id": "019e7059-bece-7681-ab38-45ae243bee0a",
    "storage_key": "property/5697689396183040/019e7059-bece-7681-ab38-45ae243bee0a.webp",
    "width": 1050,
    "height": 1050
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e7058-dcf5-7021-9a8b-1c1d8aab5712.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Access logo",
    "public_id": "019e7058-dcf5-7021-9a8b-1c1d8aab5712",
    "storage_key": "property/5697689396183040/019e7058-dcf5-7021-9a8b-1c1d8aab5712.webp",
    "width": 2311,
    "height": 1081
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e7058-ddfa-7278-b331-ba6c1848f23b.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Access logo with an abstract 'A' above the text 'THE ACCESS'.",
    "public_id": "019e7058-ddfa-7278-b331-ba6c1848f23b",
    "storage_key": "property/5697689396183040/019e7058-ddfa-7278-b331-ba6c1848f23b.webp",
    "width": 2311,
    "height": 1081
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#24338a",
  "property_secondary_color": "#01aaad",
  "property_font_color": "#2e2a25",
  "property_color_4": "#f04e37",
  "property_color_3": "#cbc912",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 3",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "485 - 1199",
  "property_sqft_min": "485",
  "property_sqft_max": "1199",
  "property_price_range": "1085 - 2684.33",
  "property_price_min": "1085",
  "property_price_max": "2684.33",
  "property_available_units": 36,
  "property_facebook_url": "https://www.facebook.com/TheAccessApartments",
  "property_instagram_url": "https://www.instagram.com/theaccessapartments",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJPYD-rR4JK4cRqvyvqsnKKu8",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/the-access-tempe",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Convenience, recharge, repeat.</strong> The Access keeps essentials simple with parcel lockers, door-to-door trash pickup, garage parking, EV charging, key-fob entry, and WiFi in shared spaces. For downtime, shift from the fitness center to the resort-style pool and hot tub, rooftop basketball court, game room, clubhouse lounge, Starbucks coffee bar, fireside seating, or summer kitchen. At home, enjoy in-home laundry, stainless steel appliances, granite countertops, tall ceilings, and vinyl hardwood-style flooring.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts with room to choose.</strong> Explore studio, one-, two-, and three-bedroom apartments in Tempe with open living areas, loft-style options, and polished finishes like in-home washers and dryers, stainless steel appliances, granite countertops, tall ceilings, and vinyl hardwood-style flooring. Select homes add walk-in closets or private balconies for even more everyday ease.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture The Access in motion.</strong> Preview bright kitchens with stainless steel appliances and tile backsplashes, polished open living areas, and Tempe-ready bedroom spaces—then step into the scene outside with poolside loungers, a fireside lounge, summer kitchen grills, a game room, fitness spaces, and a rooftop basketball court.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Flavor, light rail, and Tempe energy—right on Apache Boulevard.</strong> The Access places you near the McClintock/Apache light rail stop for easy connections to Downtown Tempe, ASU, Mesa, and beyond. Around the corridor, find standout dining like The Dhaba, Haji-Baba, Curry Corner, and Khai Hoan, plus coffee, retail, parks, arts venues, and lakefront paths. Explore the map, then see how this connected location brings Tempe closer.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents have plenty to recommend at The Access.</strong> Reviews call out clean, well-kept spaces, spacious layouts, convenient parking, in-home laundry, and easy light rail access. Just as often, feedback highlights the team’s friendly service, prompt communication, and smooth leasing and move-in experience—everyday details that make a lasting impression.</p>",
  "property_neighborhood_blurb": "<p><strong>Follow the flavor, the rail, and the rhythm of Apache Boulevard.</strong> At The Access, you’re in one of Tempe’s most connected corridors, with the McClintock/Apache light rail stop close by for easy trips toward Downtown Tempe, ASU, Mesa, and beyond.</p><p>Start nearby with Apache Boulevard’s celebrated global dining scene—think The Dhaba, Haji-Baba, Curry Corner, and Khai Hoan—then branch out to coffee stops, neighborhood retail, parks, arts venues, and lakefront paths plotted on the map below. When the day winds down, your apartment community brings you back to controlled-access comfort, <a href=\"/amenities\">relaxing shared spaces</a>, and a location that keeps Tempe moving around you. Ready to see how it all connects? <a href=\"/schedule-a-tour\">Schedule a tour</a> and explore the neighborhood from here.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that keep the day moving.</strong> At The Access, convenience is built into the routine: parcel lockers, door-to-door trash pickup, online resident services, key-fob entry, garage parking, EV charging, and WiFi in shared spaces help streamline the essentials. When it’s time to reset, move between the fitness center, resort-style pool and hot tub, rooftop basketball court, game room, clubhouse lounge, Starbucks coffee bar, fireside seating, and summer kitchen—spaces designed for quick breaks, longer stays, and everything between.</p><p>Inside, your studio to three-bedroom home pairs polished finishes with practical comfort, including in-home laundry, stainless steel appliances, granite countertops, tall ceilings, vinyl hardwood-style flooring, and select layouts with walk-in closets, garden tubs, or private balconies. Browse the <a href=\"/gallery\">photo gallery</a>, review pet-friendly perks in the <a href=\"/pet-policy\">pet policy</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see it in person.</p>",
  "property_applynow_blurb": "<p><strong>Start your application at The Access.</strong><br>Choose a studio, one-, two-, or three-bedroom apartment with modern finishes, in-home laundry, and connected Tempe access. When you’re ready, apply online and take the next step toward calling The Access home.</p>",
  "property_contactus_blurb": "<p><strong>Questions about The Access?</strong> Our leasing team is here to help with floor plans, availability, community features, or directions to our Apache Boulevard location. Reach out today and get the details you need to plan your next step in connected Tempe living.</p>",
  "property_faqs_blurb": "<p><strong>Questions about The Access?</strong> Start here for quick answers on community details, leasing, floor plans, amenities, and everyday living along Apache Boulevard. If you need anything else, the <a href=\"/contact-us\">leasing team</a> is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits your day.</strong> At The Access, floor plans range from efficient studios to roomy one-, two-, and three-bedroom apartments in Tempe, giving you options for a streamlined setup, extra separation, or more space to spread out. Compare open living areas, loft-style selections, and bedroom counts alongside current pricing and availability, then picture the details that make each home feel polished: in-home washer and dryer, stainless steel appliances, granite countertops, tall ceilings, vinyl hardwood-style flooring, and select homes with walk-in closets or private balconies. When you’re ready to look closer, browse the <a href=\"/gallery\">photo gallery</a>, explore <a href=\"/amenities\">apartment features</a>, or choose a floor plan and <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_gallery_blurb": "<p><strong>See The Access from every angle.</strong> Browse photos that bring the community into focus: bright kitchens with stainless steel appliances and tile backsplashes, open living areas with polished flooring, and bedroom scenes that help you picture your own setup in Tempe.</p><p>Move from interiors to the moments just outside your door—loungers beside the <a href=\"/amenities\">resort-style pool</a>, the glow of the fireside lounge, grills in the summer kitchen, a lively game room, fitness spaces, and the rooftop basketball court. Like what you see? Keep exploring with <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the details in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore connected Tempe living.</strong> Use the interactive map to browse available apartments at The Access and see how Apache Boulevard, light rail, the Tempe Streetcar connection, ASU, Loop 101, Downtown Tempe, Mill Avenue, and Tempe Town Lake all come together around your next home.</p>",
  "property_pets_blurb": "<p><strong>Pet life fits right in at The Access.</strong> Bring up to two cats or dogs and make everyday care easier with a bark park on site, door-to-door trash pickup, package lockers for food and toy deliveries, and key-fob access for quick exits when it’s time for a walk. Inside, easy-care finishes, in-home laundry, air conditioning, and select private balconies help your space work for both you and your pet.</p><p>When your dog needs more room to run, Tempe’s free off-leash dog parks add more options around town; when it’s time to unwind, the courtyard and outdoor lounge areas keep fresh-air breaks close to home. Review the pet policy below, then explore more <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how your routine can settle in.</p>",
  "property_referafriend_blurb": "<p><strong>Share connected Tempe living.</strong> Love the easy access, polished apartment finishes, and community spaces like the resort-style pool, rooftop basketball court, and Starbucks coffee bar? Refer a friend to The Access and invite them to make it their next address.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access made simple.</strong> Log in to pay rent, submit maintenance requests, and manage your account at The Access—your connected Tempe home base along the Apache Boulevard corridor.</p>",
  "property_reviews_blurb": "<p><strong>See why residents recommend The Access.</strong> In reviews, residents highlight a clean, well-kept apartment community with helpful service, spacious layouts, convenient parking, and easy access to nearby light rail.</p><p>You’ll also see praise for everyday comforts like in-home laundry, well-maintained community spaces, and a team that makes leasing and move-in feel “quick, easy and seamless.” From first questions to renewal support, reviewers call out the leasing staff’s friendliness, prompt communication, and welcoming approach—details that help make The Access feel like home.</p>",
  "property_created_at": "1752256541885",
  "property_scheduletour_blurb": "<p><strong>See connected Tempe living up close.</strong> Tour studio to three-bedroom floor plans with polished finishes, then explore the pool, rooftop basketball court, clubhouse lounge, coffee bar, and more. Schedule your visit to The Access and picture how it all comes together.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong><br>The leasing team will follow up soon with next steps. In the meantime, picture connected Tempe living with comfortable <a href=\"/floor-plans\">floor plans</a>, polished in-home finishes, and energizing community spaces at The Access.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you stop by.</strong> The virtual tours at The Access let you move through the community experience and a one-bedroom apartment walkthrough from wherever you are. Start with Virtual Tour 1 to get a feel for the shared setting, then open the 1BR, 1BA tour for a closer look at the home’s flow, finishes, and everyday function in Tempe.</p><p>Inside the apartment tour, notice the wood-look flooring, natural light, stainless steel kitchen appliances, granite countertops with breakfast-bar seating, walk-in closet storage, and polished bath details that are easier to appreciate in 3D. Compare what you see with current <a href=\"/floor-plans\">floor plan options</a>, browse more views in the <a href=\"/gallery\">photo gallery</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to experience The Access in person.</p>",
  "property_copyright": "2025 All Rights Reserved. The Access",
  "property_seo_title_home": "Home | The Access",
  "property_seo_description_home": "Experience modern living at The Access in Tempe, AZ. With diverse floor plans and premium amenities, your perfect home awaits. Find your new space today!",
  "property_seo_title_floorplans": "Floor Plans | Tempe, AZ Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at The Access in Tempe, AZ! Choose from charming studios to spacious three-bedroom apartments and enjoy modern living tailored for you.",
  "property_seo_title_amenities": "Amenities | Tempe, AZ Apartments for Rent",
  "property_seo_description_amenities": "Embrace comfort at The Access in Tempe, AZ! From spacious floor plans to premium amenities like a dog park, fitness center, and resort-style pool—all waiting for you!",
  "property_seo_title_gallery": "Gallery | Apartments in Tempe, AZ",
  "property_seo_description_gallery": "Imagine your life at The Access in Tempe, AZ! Picture stunning amenities, diverse floor plans, and a vibrant community. Make that dream a reality today!",
  "property_seo_title_virtualtours": "Virtual Tours | The Access Apartments",
  "property_seo_description_virtualtours": "Experience The Access in Tempe, AZ! Take a virtual tour and discover stunning one, two, and three-bedroom apartments tailored for your lifestyle. Join us today!",
  "property_seo_title_interactivemap": "Interactive Map | The Access Apartments",
  "property_seo_description_interactivemap": "Find your perfect fit at The Access in Tempe! Use our interactive community map to uncover stylish studio to three-bedroom apartments with top-notch amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Tempe, AZ",
  "property_seo_description_neighborhood": "Uncover Tempe’s vibrant charm at The Access! Dive into local favorites and discover the perfect blend of comfort and convenience right outside your door.",
  "property_seo_title_contact": "Contact Us | The Access",
  "property_seo_description_contact": "Connect with us at The Access in Tempe, AZ! Inquire about our one to three-bedroom apartments and studio options. Your ideal home awaits—reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Tempe, AZ",
  "property_seo_description_faqs": "Find answers to your questions about The Access in Tempe, AZ. From floor plans to amenities, our FAQs page has everything you need for your new home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Tempe, AZ",
  "property_seo_description_reviews": "See how The Access in Tempe, AZ fosters community vibes! From spacious layouts to luxury amenities, our residents love calling this place home! Join us!",
  "property_seo_title_applynow": "Apply Now | Apartments in Tempe, AZ",
  "property_seo_description_applynow": "Elevate your lifestyle at The Access in Tempe, AZ! Choose from modern floor plans, indulge in top-notch amenities, and lease your dream home today!",
  "property_seo_title_residentaccess": "Resident Access | The Access",
  "property_seo_description_residentaccess": "Log in to The Access resident portal in Tempe, AZ, for easy rent payments, hassle-free maintenance requests, and everything you need at your fingertips!",
  "property_seo_title_referafriend": "Refer A Friend | The Access",
  "property_seo_description_referafriend": "Refer a friend to The Access in Tempe, AZ! Great friends make great neighbors—share the love and enjoy an extraordinary living experience together!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Access",
  "property_seo_description_scheduletour": "Experience vibrant living at The Access in Tempe, AZ. Schedule your tour today and step into your future home where comfort meets style!",
  "property_seo_title_privacy": "Privacy Policy | The Access",
  "property_seo_description_privacy": "Your privacy matters at The Access in Tempe, AZ. Learn how we protect your information and ensure a safe living experience. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | The Access",
  "property_seo_description_accessibility": "At The Access in Tempe, AZ, we prioritize digital inclusion. Experience our commitment to accessibility and find your ideal home today!",
  "property_seo_title_sitemap": "Sitemap | The Access",
  "property_seo_description_sitemap": "Navigate The Access in Tempe, AZ with ease! Check out our sitemap for quick links to amenities, floor plans, and community highlights. Your perfect home awaits!",
  "property_seo_title_thankyou": "Thank You | The Access",
  "property_seo_description_thankyou": "Thank you for connecting with The Access in Tempe, AZ! Our team will reach out soon—exciting living awaits you at your new home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Austell, GA\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234320346",
  "amenities": [
    {
      "id": "custom_404fa02c-2526-4fea-bf5c-8da1e23ac97f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fa0cdf35-00e4-4c00-aec4-7d590ff6835a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_36ed3f07-853a-47ac-9e95-e97d98dde479",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "external_id": "P000000641",
      "title": "Garden Tub",
      "amount": "0.0000",
      "description": "Garden Tubs*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_246f57bc-cd40-4d8a-8669-e763a53237ac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Generous Walk-In Closets*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1e38610b-bc74-4b81-867c-5fc8f1ac87af",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Granite Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5e29b218-5b69-469d-beac-420ecd343d10",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Balconies*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ee13b8bc-fa10-46aa-9cbb-a17273a2a127",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Decorative Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fc0d107c-8a76-4777-9721-899e5c7e2c32",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Vinyl Hardwood Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f4843f2e-1ba4-4107-8271-32bc08bddbc3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "external_id": "P000000606",
      "title": "Built-In Microwave",
      "amount": "0.0000",
      "description": "Built-In Microwave",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7d8a24a2-aba4-4f79-9d2a-9262854cbec8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "Tall Ceilings",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4de26302-8aa3-4519-8f9b-23ee645e38ea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fa556d3f-7330-47b4-98b9-63ea56716cc3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_212cb329-01e2-4d22-98b9-4f7349b62abe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "external_id": "P000000662",
      "title": "Outdoor Kitchen",
      "amount": "0.0000",
      "description": "Community Summer Kitchen",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f31bae6f-bafa-4c0c-8f4e-c02f189149a9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern Fitness Center & Spin Room",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b7e38855-38dd-4156-99d5-b6e2de8e60f5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "Parcel Pending Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_feb98721-066a-4d2e-be57-217b3cad9d56",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Style Swimming Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0230291d-238c-4db0-9fa3-b4c6c5461131",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "external_id": "P000000682",
      "title": "Spa",
      "amount": "0.0000",
      "description": "Outdoor Spa",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_61592009-cc5f-40c0-a17f-3df2da1be080",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "external_id": "P000000615",
      "title": "Coffee Bar",
      "amount": "0.0000",
      "description": "Starbucks Coffee Bar",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_006fb0e4-c5a8-4a3f-b08d-e77be274a90a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "external_id": "P000000634",
      "title": "Fire Pit",
      "amount": "0.0000",
      "description": "Community Fire Side Lounge",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bd02c3e9-c277-446f-b560-6b17f24d3e0c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "external_id": "P000000610",
      "title": "Car Charging Stations",
      "amount": "0.0000",
      "description": "Electric Car Charging Stations",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5e175c58-24cd-42c8-9196-31d9cc6fd4f5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "external_id": "P000000640",
      "title": "Garages",
      "amount": "0.0000",
      "description": "Free Garage Parking Available",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6f991bdd-7c28-4339-a427-1eb9a0f71717",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "external_id": "P000002520",
      "title": "Resident Clubhouse",
      "amount": "0.0000",
      "description": "Resident Clubhouse, Game Room & Lounge",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f664baed-ee28-4d9f-83d0-e9637034158a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "external_id": "P000001409",
      "title": "WiFi at Pool & Clubhouse",
      "amount": "0.0000",
      "description": "WiFi at Pool & Clubhouse",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_437fe584-1dcf-4a6d-b86c-5e4e6b3d69a8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_88deb515-14cf-49f4-a1d5-5498aec56786",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_c5c97c06-70ed-4a65-9daf-9263680d7273",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c2-15bc-70a9-bb86-e985f5ae95ab.webp",
      "image_media": {
        "alt_text": "Ping pong table, arcade games, and fitness center in apartment community.",
        "public_id": "019e89c2-15bc-70a9-bb86-e985f5ae95ab",
        "storage_key": "property/5697689396183040/019e89c2-15bc-70a9-bb86-e985f5ae95ab.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a variety of recreational activities at our community, featuring a ping pong table, arcade games, and a well-equipped fitness center.",
      "link": "",
      "alt_text": "Ping pong table, arcade games, and fitness center in apartment community.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ef0531c7-2203-40bb-b225-4ac0418df7c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c2-1a5a-761f-9a84-a63a6c94cb93.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, toilet, and vanity with a granite countertop.",
        "public_id": "019e89c2-1a5a-761f-9a84-a63a6c94cb93",
        "storage_key": "property/5697689396183040/019e89c2-1a5a-761f-9a84-a63a6c94cb93.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a clean white bathtub with a patterned shower curtain, a toilet, and a sleek vanity with a granite countertop and silver fixtures.",
      "link": "",
      "alt_text": "Bathroom with a bathtub, toilet, and vanity with a granite countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f5a2b60e-0b98-4128-9995-14e32e07ff25",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c2-16f6-744a-9153-a82759713d4e.webp",
      "image_media": {
        "alt_text": "Gym with dumbbells, weight bench, medicine balls, and yoga mat.",
        "public_id": "019e89c2-16f6-744a-9153-a82759713d4e",
        "storage_key": "property/5697689396183040/019e89c2-16f6-744a-9153-a82759713d4e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring free weights, cardio equipment, and space for stretching and yoga.",
      "link": "",
      "alt_text": "Gym with dumbbells, weight bench, medicine balls, and yoga mat.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cbdb8022-dd8c-4bf0-a0ea-4da44232cfa1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c2-16d9-706b-b821-5b8e2e93b1ac.webp",
      "image_media": {
        "alt_text": "King-size bed with gray and blue pillows and a colorful abstract painting above the headboard.",
        "public_id": "019e89c2-16d9-706b-b821-5b8e2e93b1ac",
        "storage_key": "property/5697689396183040/019e89c2-16d9-706b-b821-5b8e2e93b1ac.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Relax in comfort in this spacious bedroom, featuring a plush king-size bed, elegant nightstand, and vibrant wall art.",
      "link": "",
      "alt_text": "King-size bed with gray and blue pillows and a colorful abstract painting above the headboard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_59794e01-593d-436f-84dd-c4d24aaa0e3e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c2-11cb-73e3-9345-bbf7080ec78f.webp",
      "image_media": {
        "alt_text": "A resort-style swimming pool with lounge chairs and umbrellas, set against a backdrop of a modern apartment building.",
        "public_id": "019e89c2-11cb-73e3-9345-bbf7080ec78f",
        "storage_key": "property/5697689396183040/019e89c2-11cb-73e3-9345-bbf7080ec78f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxation and soaking up the sun.",
      "link": "",
      "alt_text": "A resort-style swimming pool with lounge chairs and umbrellas, set against a backdrop of a modern apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_18ea3019-000a-4cac-9a46-7636755e9753",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c2-145c-74a5-872b-fe3fd3212b12.webp",
      "image_media": {
        "alt_text": "Spacious walk-in closet with built-in shelves, a clothing rod, and a decorative stool.",
        "public_id": "019e89c2-145c-74a5-872b-fe3fd3212b12",
        "storage_key": "property/5697689396183040/019e89c2-145c-74a5-872b-fe3fd3212b12.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Organize your belongings in this ample walk-in closet, featuring convenient built-in shelving and a hanging rod for all your clothing needs.",
      "link": "",
      "alt_text": "Spacious walk-in closet with built-in shelves, a clothing rod, and a decorative stool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_202a8560-38bc-4f50-97b6-d0d1cab60b3b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c2-14d5-7663-b64f-53e56dd2bc7c.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with comfortable seating and modern decor.",
        "public_id": "019e89c2-14d5-7663-b64f-53e56dd2bc7c",
        "storage_key": "property/5697689396183040/019e89c2-14d5-7663-b64f-53e56dd2bc7c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed community lounge, featuring plush seating and contemporary accents for your comfort and enjoyment.",
      "link": "",
      "alt_text": "Stylish lounge area with comfortable seating and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3e3ed461-72cf-4b10-884a-84034b20201f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c2-0f60-712a-b8bf-83e4b15373f6.webp",
      "image_media": {
        "alt_text": "Smart package lockers in a modern apartment building.",
        "public_id": "019e89c2-0f60-712a-b8bf-83e4b15373f6",
        "storage_key": "property/5697689396183040/019e89c2-0f60-712a-b8bf-83e4b15373f6.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Secure and convenient smart package lockers for residents, featuring a digital interface and organized storage solutions. Located in the leasing office area.",
      "link": "",
      "alt_text": "Smart package lockers in a modern apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_54bd39de-e974-4daf-b593-3a2f97394553",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c2-0565-7799-bf6f-b2ad4f4f1845.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and gray cabinets.",
        "public_id": "019e89c2-0565-7799-bf6f-b2ad4f4f1845",
        "storage_key": "property/5697689396183040/019e89c2-0565-7799-bf6f-b2ad4f4f1845.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring stainless steel appliances, a deep sink, ample cabinet space, and granite countertops.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and gray cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_513d6533-f9dc-4925-ad28-8a02b0a24097",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c1-f869-77de-a532-05a1721489d6.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and courtyard area with lounge chairs and umbrellas.",
        "public_id": "019e89c1-f869-77de-a532-05a1721489d6",
        "storage_key": "property/5697689396183040/019e89c1-f869-77de-a532-05a1721489d6.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Enjoy our beautiful resort-style swimming pool and courtyard, perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool and courtyard area with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_18bcffdc-fb0e-44ce-8846-5f2935677388",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c1-f7ac-7222-80bb-9978b00b4f43.webp",
      "image_media": {
        "alt_text": "Row of stationary bikes and treadmills in a modern gym.",
        "public_id": "019e89c1-f7ac-7222-80bb-9978b00b4f43",
        "storage_key": "property/5697689396183040/019e89c1-f7ac-7222-80bb-9978b00b4f43.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring cardio equipment and weight machines.",
      "link": "",
      "alt_text": "Row of stationary bikes and treadmills in a modern gym.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_614e0abb-a881-4eee-8e1c-f56bb0efde6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c1-e46f-70ac-af63-825d32cc38d4.webp",
      "image_media": {
        "alt_text": "Modern living room with abstract blue wall art and a white sectional sofa.",
        "public_id": "019e89c1-e46f-70ac-af63-825d32cc38d4",
        "storage_key": "property/5697689396183040/019e89c1-e46f-70ac-af63-825d32cc38d4.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a large abstract blue mural, a comfortable white sectional, and a TV displaying a yoga scene. Perfect for relaxation and entertainment.",
      "link": "",
      "alt_text": "Modern living room with abstract blue wall art and a white sectional sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f6cc5048-61bf-4494-a4ac-501665f435c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c1-e4b2-77cd-9676-ff933745a53b.webp",
      "image_media": {
        "alt_text": "Outdoor built-in gas grills with stone accents and stainless steel doors.",
        "public_id": "019e89c1-e4b2-77cd-9676-ff933745a53b",
        "storage_key": "property/5697689396183040/019e89c1-e4b2-77cd-9676-ff933745a53b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy cooking and entertaining with these premium outdoor grills, perfect for community gatherings and resident events.",
      "link": "",
      "alt_text": "Outdoor built-in gas grills with stone accents and stainless steel doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_11e8080e-75a5-4901-8058-ddabf02a942d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c1-e582-744c-b085-f1edf5b8eb27.webp",
      "image_media": {
        "alt_text": "Fitness center with dumbbells, weight benches, and cardio equipment.",
        "public_id": "019e89c1-e582-744c-b085-f1edf5b8eb27",
        "storage_key": "property/5697689396183040/019e89c1-e582-744c-b085-f1edf5b8eb27.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, equipped with everything you need for a great workout.",
      "link": "",
      "alt_text": "Fitness center with dumbbells, weight benches, and cardio equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9f154ea8-2d0c-4c41-9940-387a55e30009",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c1-e0c9-7619-a7c4-f75d07b79d1d.webp",
      "image_media": {
        "alt_text": "A fenced-in dog park with artificial turf, agility equipment, and benches.",
        "public_id": "019e89c1-e0c9-7619-a7c4-f75d07b79d1d",
        "storage_key": "property/5697689396183040/019e89c1-e0c9-7619-a7c4-f75d07b79d1d.webp",
        "width": 3072,
        "height": 2300
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, a dedicated space for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "A fenced-in dog park with artificial turf, agility equipment, and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_64d924e8-984c-430a-889e-1414c6b8e553",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c1-e467-70ac-8902-29984bdf1719.webp",
      "image_media": {
        "alt_text": "Community game room with pool table, arcade games, ping pong table, and a TV on a living green wall.",
        "public_id": "019e89c1-e467-70ac-8902-29984bdf1719",
        "storage_key": "property/5697689396183040/019e89c1-e467-70ac-8902-29984bdf1719.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy our community's game room, featuring a pool table, arcade games, ping pong table, and a television with scenic views, all set against a vibrant living green wall.",
      "link": "",
      "alt_text": "Community game room with pool table, arcade games, ping pong table, and a TV on a living green wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_585a84d7-ca35-45d7-a4bb-dbab36717d16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c1-de87-74d9-a4fc-ecc10a775735.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, dining area, and television.",
        "public_id": "019e89c1-de87-74d9-a4fc-ecc10a775735",
        "storage_key": "property/5697689396183040/019e89c1-de87-74d9-a4fc-ecc10a775735.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Modern living room featuring a comfortable sofa, a stylish coffee table, a dining area, and a wall-mounted television. This space is perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with sofa, coffee table, dining area, and television.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0514f987-fc2e-40de-86f4-6799e406bcaf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c1-e148-729e-82f4-d07edeb096ab.webp",
      "image_media": {
        "alt_text": "Modern bedroom with white bed, black accent wall, and sliding glass doors.",
        "public_id": "019e89c1-e148-729e-82f4-d07edeb096ab",
        "storage_key": "property/5697689396183040/019e89c1-e148-729e-82f4-d07edeb096ab.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a comfortable white bed, striking black accent wall, and ample natural light from sliding glass doors. Perfect for relaxation.",
      "link": "",
      "alt_text": "Modern bedroom with white bed, black accent wall, and sliding glass doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5daaf0bd-e9e9-4dda-93d3-a5ccdf83a705",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c1-de3a-77fe-b059-abcd31642747.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a blue accent wall.",
        "public_id": "019e89c1-de3a-77fe-b059-abcd31642747",
        "storage_key": "property/5697689396183040/019e89c1-de3a-77fe-b059-abcd31642747.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring sleek gray cabinetry, granite countertops, and stainless steel appliances, perfect for culinary enthusiasts.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a blue accent wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6b8e7da3-b9ec-4df9-bdd3-cb3affa68b49",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c1-aba9-702e-988f-57ae5e7b7c2d.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment building exterior with a parking lot and surrounding cityscape.",
        "public_id": "019e89c1-aba9-702e-988f-57ae5e7b7c2d",
        "storage_key": "property/5697689396183040/019e89c1-aba9-702e-988f-57ae5e7b7c2d.webp",
        "width": 3072,
        "height": 2300
      },
      "title": "Community",
      "description": "An aerial view showcasing the contemporary architecture of an apartment complex, featuring its exterior design and surrounding urban environment.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment building exterior with a parking lot and surrounding cityscape.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_af46c0e1-2149-4458-b585-2f61302461c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c1-af64-72ee-8201-bcb168d7cbe6.webp",
      "image_media": {
        "alt_text": "Kitchen area with washing machine, dryer, and granite countertops.",
        "public_id": "019e89c1-af64-72ee-8201-bcb168d7cbe6",
        "storage_key": "property/5697689396183040/019e89c1-af64-72ee-8201-bcb168d7cbe6.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring in-unit laundry, granite countertops, and stainless steel appliances.",
      "link": "",
      "alt_text": "Kitchen area with washing machine, dryer, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_74e9fed0-60d0-479b-ac58-4de214ab604e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c1-ab0e-7718-829c-cb2a9fa9b424.webp",
      "image_media": {
        "alt_text": "Interior view of a modern apartment with a dining area and a glimpse into the bedroom.",
        "public_id": "019e89c1-ab0e-7718-829c-cb2a9fa9b424",
        "storage_key": "property/5697689396183040/019e89c1-ab0e-7718-829c-cb2a9fa9b424.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Discover comfortable living in this well-appointed apartment, featuring a stylish dining nook and a serene bedroom. An ideal space for relaxation and entertaining.",
      "link": "",
      "alt_text": "Interior view of a modern apartment with a dining area and a glimpse into the bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9aa74b60-c5c2-4220-9c7b-b43265927478",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c1-aa16-739d-94c4-60c35f635ee4.webp",
      "image_media": {
        "alt_text": "Modern apartment complex courtyard with a sparkling pool, fire pit, and lounge chairs.",
        "public_id": "019e89c1-aa16-739d-94c4-60c35f635ee4",
        "storage_key": "property/5697689396183040/019e89c1-aa16-739d-94c4-60c35f635ee4.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind by the resort-style pool, gather around the fire pit with friends, or soak up the sun on comfortable lounge chairs in this vibrant community courtyard.",
      "link": "",
      "alt_text": "Modern apartment complex courtyard with a sparkling pool, fire pit, and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b2dfbf87-06a4-4d21-a829-7d7aaf5fc88c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c1-7905-7561-8e9a-22d1c517f786.webp",
      "image_media": {
        "alt_text": "Modern communal lounge with a granite-topped island bar and seating.",
        "public_id": "019e89c1-7905-7561-8e9a-22d1c517f786",
        "storage_key": "property/5697689396183040/019e89c1-7905-7561-8e9a-22d1c517f786.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish communal lounge, featuring a sleek island bar perfect for gathering with friends or enjoying a quick refreshment.",
      "link": "",
      "alt_text": "Modern communal lounge with a granite-topped island bar and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0c50f5d4-dedf-43cd-a03e-5c6e4799a0c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c1-7912-74b9-b640-cf1de6e2c19a.webp",
      "image_media": {
        "alt_text": "Modern lounge area with comfortable chairs and a round coffee table.",
        "public_id": "019e89c1-7912-74b9-b640-cf1de6e2c19a",
        "storage_key": "property/5697689396183040/019e89c1-7912-74b9-b640-cf1de6e2c19a.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge area, perfect for meeting neighbors or enjoying a quiet moment.",
      "link": "",
      "alt_text": "Modern lounge area with comfortable chairs and a round coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4c8b3c6e-d462-426e-8c62-58a7b2323535",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c1-7712-76d8-9e8d-e03bfb958625.webp",
      "image_media": {
        "alt_text": "Gym with weight machines, cardio equipment, and exercise mats.",
        "public_id": "019e89c1-7712-76d8-9e8d-e03bfb958625",
        "storage_key": "property/5697689396183040/019e89c1-7712-76d8-9e8d-e03bfb958625.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of weight machines and cardio equipment for a complete workout.",
      "link": "",
      "alt_text": "Gym with weight machines, cardio equipment, and exercise mats.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6ece7359-c697-4946-9490-9f64da403170",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c1-7800-7379-92f1-63d94e283c16.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
        "public_id": "019e89c1-7800-7379-92f1-63d94e283c16",
        "storage_key": "property/5697689396183040/019e89c1-7800-7379-92f1-63d94e283c16.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring stainless steel appliances, ample cabinet space, and elegant granite countertops.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e1e31270-b417-4967-8a25-fb8e1a8cd853",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019e89c1-4fe4-70ed-97b2-a0e5e5652a7e.webp",
      "image_media": {
        "alt_text": "Modern lounge area with geometric patterned walls, black chairs, and a sleek epoxy floor.",
        "public_id": "019e89c1-4fe4-70ed-97b2-a0e5e5652a7e",
        "storage_key": "property/5697689396183040/019e89c1-4fe4-70ed-97b2-a0e5e5652a7e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish lounge, featuring contemporary seating, unique wall art, and a striking epoxy floor that adds a modern touch to the community space.",
      "link": "",
      "alt_text": "Modern lounge area with geometric patterned walls, black chairs, and a sleek epoxy floor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_ffe1c48857acbdd7dbe0ee91",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Bora Bora Smoothie Cafe -Apache Blvd",
      "poi_type": "Restaurants",
      "poi_address": "1811 E Apache Blvd #110, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-8801-733c-a221-c520880df75b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-8801-733c-a221-c520880df75b",
        "storage_key": "property/5697689396183040/019f14fa-8801-733c-a221-c520880df75b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://boraborausa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7710454436485745113&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bora-bora-smoothie-cafe--apache-blvd",
      "poi_latitude": "33.41449290000001",
      "poi_longitude": "-111.9088306",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 480-580-9873",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-4aff-729e-bf9a-31c76aa8a11f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-4aff-729e-bf9a-31c76aa8a11f",
        "storage_key": "property/5697689396183040/019f14fb-4aff-729e-bf9a-31c76aa8a11f.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJESBo7XUJK4cR2UmRT3UJAWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_eb029bd51c3b9e73d025b453",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Ziggi's Coffee",
      "poi_type": "Restaurants",
      "poi_address": "1135 E Apache Blvd Ste 113, Tempe, AZ 85281, USA",
      "poi_short_description": "Local coffeehouse chain serving classic brews & blended drinks, plus smoothies & light eats.",
      "poi_long_description": "Local coffeehouse chain serving classic brews & blended drinks, plus smoothies & light eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-903d-771d-a7b3-f77827d3623b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-903d-771d-a7b3-f77827d3623b",
        "storage_key": "property/5697689396183040/019f14fa-903d-771d-a7b3-f77827d3623b.webp",
        "width": 1280,
        "height": 860
      },
      "poi_business_url": "https://www.ziggiscoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12332560128485346075&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ziggis-coffee",
      "poi_latitude": "33.4144328",
      "poi_longitude": "-111.9207398",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 480-801-6414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-4aff-729e-bf9a-31c76aa8a11f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-4aff-729e-bf9a-31c76aa8a11f",
        "storage_key": "property/5697689396183040/019f14fb-4aff-729e-bf9a-31c76aa8a11f.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ-952-H4JK4cRG8uDnRgOJqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_600ba47d28ff71cbe126ea4b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Shaghf Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1250 E Apache Blvd #116, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-8871-76a9-b2ba-f866bf283333.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-8871-76a9-b2ba-f866bf283333",
        "storage_key": "property/5697689396183040/019f14fa-8871-76a9-b2ba-f866bf283333.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.shaghfcafeaz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15283947029163909963&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shaghf-cafe",
      "poi_latitude": "33.4154894",
      "poi_longitude": "-111.9179616",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 480-590-4909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-4aff-729e-bf9a-31c76aa8a11f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-4aff-729e-bf9a-31c76aa8a11f",
        "storage_key": "property/5697689396183040/019f14fb-4aff-729e-bf9a-31c76aa8a11f.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJz9GmzoAJK4cRS6MzX9h8G9Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_322b7eed965d33021139dae8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Aruma Cafe",
      "poi_type": "Restaurants",
      "poi_address": "2011 E Apache Blvd #143, Tempe, AZ 85281, USA",
      "poi_short_description": "Casual coffeehouse serving breakfast and quick bites, plus beer and other alcoholic beverages.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-8bfa-76a3-a0d6-fd2f3f5129a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-8bfa-76a3-a0d6-fd2f3f5129a7",
        "storage_key": "property/5697689396183040/019f14fa-8bfa-76a3-a0d6-fd2f3f5129a7.webp",
        "width": 814,
        "height": 1280
      },
      "poi_business_url": "https://www.arumacafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14340479364135662722&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aruma-cafe",
      "poi_latitude": "33.4145214",
      "poi_longitude": "-111.8998162",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 602-486-5235",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-4aff-729e-bf9a-31c76aa8a11f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-4aff-729e-bf9a-31c76aa8a11f",
        "storage_key": "property/5697689396183040/019f14fb-4aff-729e-bf9a-31c76aa8a11f.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ-_IROAAJK4cRgjQgqACeA8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_eeb8911f999abaf0f55bc599",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Spitz Restaurant - Tempe At ASU",
      "poi_type": "Restaurants",
      "poi_address": "681 E Apache Blvd, Tempe, AZ 85281, USA",
      "poi_short_description": "Vegan and traditional versions of Mediterranean fare like gyros served in a hip space for lunch and dinner, plus delivery.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-9619-748f-9ba4-063443a26adc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-9619-748f-9ba4-063443a26adc",
        "storage_key": "property/5697689396183040/019f14fa-9619-748f-9ba4-063443a26adc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://spitz-restaurant.com/mediterranean-food-tempe-asu-bar-restaurant/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2384953224312833457&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spitz-restaurant---tempe-at-asu",
      "poi_latitude": "33.4141431",
      "poi_longitude": "-111.9288908",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 480-590-0161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d551-752a-ac36-e6c400ca163e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d551-752a-ac36-e6c400ca163e",
        "storage_key": "property/5697689396183040/019d02f1-d551-752a-ac36-e6c400ca163e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBQ34LAwJK4cRscUWTVIOGSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_059951f18a80c79aac3a5f7b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Postino Annex",
      "poi_type": "Restaurants",
      "poi_address": "615 S College Ave, Tempe, AZ 85281, USA",
      "poi_short_description": "Hip eatery featuring brunch fare, a patio and wine specials.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-8ddb-758c-bed8-dd8011e825e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-8ddb-758c-bed8-dd8011e825e2",
        "storage_key": "property/5697689396183040/019f14fa-8ddb-758c-bed8-dd8011e825e2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.postino.com/locations/postino-annex",
      "poi_directions_map_url": "https://maps.google.com/?cid=8684110760763484041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "postino-annex",
      "poi_latitude": "33.4238482",
      "poi_longitude": "-111.9347356",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 480-927-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d551-752a-ac36-e6c400ca163e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d551-752a-ac36-e6c400ca163e",
        "storage_key": "property/5697689396183040/019d02f1-d551-752a-ac36-e6c400ca163e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9Wd6mGYGK4cRiWd0_bkohHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_871fec68a106e70be0162de7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Caffe Boa TEMPE",
      "poi_type": "Restaurants",
      "poi_address": "398 S Mill Ave, Tempe, AZ 85281, USA",
      "poi_short_description": "European fare with a market-driven focus served in an airy, contemporary space with brick accents.",
      "poi_long_description": "European fare with a market-driven focus served in an airy, contemporary space with brick accents.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-8265-774a-a1bd-122735524012.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-8265-774a-a1bd-122735524012",
        "storage_key": "property/5697689396183040/019f14fa-8265-774a-a1bd-122735524012.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://www.cafeboa.com/#about",
      "poi_directions_map_url": "https://maps.google.com/?cid=1543461327568053548&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "caffe-boa-tempe",
      "poi_latitude": "33.4266981",
      "poi_longitude": "-111.940372",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 480-968-9112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d551-752a-ac36-e6c400ca163e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d551-752a-ac36-e6c400ca163e",
        "storage_key": "property/5697689396183040/019d02f1-d551-752a-ac36-e6c400ca163e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSa0ZCCgJK4cRLCU_WuZ5axU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_e361dc54bbf0b5b1d876deea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Pedal Haus Brewery",
      "poi_type": "Restaurants",
      "poi_address": "730 S Mill Ave #102, Tempe, AZ 85281, USA",
      "poi_short_description": "Creative American eats pair with house beers & cocktails in industrial-chic surrounds with a patio.",
      "poi_long_description": "Creative American eats pair with house beers & cocktails in industrial-chic surrounds with a patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-8265-774a-a1bd-0e5d9e97029f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-8265-774a-a1bd-0e5d9e97029f",
        "storage_key": "property/5697689396183040/019f14fa-8265-774a-a1bd-0e5d9e97029f.webp",
        "width": 640,
        "height": 360
      },
      "poi_business_url": "https://pedalhausbrewery.com/tempe-location",
      "poi_directions_map_url": "https://maps.google.com/?cid=17766701310158240039&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pedal-haus-brewery",
      "poi_latitude": "33.4232907",
      "poi_longitude": "-111.9415306",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 480-314-2337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d551-752a-ac36-e6c400ca163e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d551-752a-ac36-e6c400ca163e",
        "storage_key": "property/5697689396183040/019d02f1-d551-752a-ac36-e6c400ca163e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhWoaddcIK4cRJ_lyprUAkPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_8d831c7df2d0923c2a178d9f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Shady Park",
      "poi_type": "Restaurants",
      "poi_address": "26 E University Dr, Tempe, AZ 85281, USA",
      "poi_short_description": "Hip indoor-outdoor hangout featuring sushi & ramen, plus beer, wine, sake & live music.",
      "poi_long_description": "Hip indoor-outdoor hangout featuring sushi & ramen, plus beer, wine, sake & live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-8744-70c9-beaf-30acf000266e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-8744-70c9-beaf-30acf000266e",
        "storage_key": "property/5697689396183040/019f14fa-8744-70c9-beaf-30acf000266e.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.shadyparktempe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18336228768416862690&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shady-park",
      "poi_latitude": "33.4222149",
      "poi_longitude": "-111.9387333",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 480-474-4222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d551-752a-ac36-e6c400ca163e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d551-752a-ac36-e6c400ca163e",
        "storage_key": "property/5697689396183040/019d02f1-d551-752a-ac36-e6c400ca163e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPSlpldkIK4cR4hHJVeped_4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ramen_restaurant"
    },
    {
      "id": "ec_330a3a284d9e6c2fbc8759f3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Perfect Pear Bistro",
      "poi_type": "Restaurants",
      "poi_address": "603 W University Dr, Tempe, AZ 85281, USA",
      "poi_short_description": "Casual, healthy, airy spot serving sandwiches, tacos and craft beer in relaxed surroundings.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-8290-735b-8473-4b63a6f7303b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-8290-735b-8473-4b63a6f7303b",
        "storage_key": "property/5697689396183040/019f14fa-8290-735b-8473-4b63a6f7303b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.perfectpearbistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=431952592858488181&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "perfect-pear-bistro",
      "poi_latitude": "33.4217",
      "poi_longitude": "-111.9476",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 480-966-7327",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d551-752a-ac36-e6c400ca163e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d551-752a-ac36-e6c400ca163e",
        "storage_key": "property/5697689396183040/019d02f1-d551-752a-ac36-e6c400ca163e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyWP3NtQIK4cRdZ0jOZia_gU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_1f2bcc739f1998453e5497b6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Sauce Pizza & Wine",
      "poi_type": "Restaurants",
      "poi_address": "705 S Myrtle Ave, Tempe, AZ 85281, USA",
      "poi_short_description": "Local Italian chain serving pizza, pasta & panini, plus beer & wine, in a casual setting.",
      "poi_long_description": "Local Italian chain serving pizza, pasta & panini, plus beer & wine, in a casual setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-a229-75d7-857b-eb0e87804ad0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-a229-75d7-857b-eb0e87804ad0",
        "storage_key": "property/5697689396183040/019f14fa-a229-75d7-857b-eb0e87804ad0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.saucepizzaandwine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6945359181448077811&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sauce-pizza--wine",
      "poi_latitude": "33.4230053",
      "poi_longitude": "-111.9379645",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 480-597-4260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d551-752a-ac36-e6c400ca163e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d551-752a-ac36-e6c400ca163e",
        "storage_key": "property/5697689396183040/019d02f1-d551-752a-ac36-e6c400ca163e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQxHyiV8JK4cR8-G1n2DfYmA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_7f08221bfef271e9889c061f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Four Peaks Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "1340 E 8th St, Tempe, AZ 85281, USA",
      "poi_short_description": "This working brewery also features a sizable eatery with patio seating & a menu of burgers & pizza.",
      "poi_long_description": "This working brewery also features a sizable eatery with patio seating & a menu of burgers & pizza.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-8040-76fc-a7fc-ee86bc776b30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f1-8040-76fc-a7fc-ee86bc776b30",
        "storage_key": "property/5697689396183040/019d02f1-8040-76fc-a7fc-ee86bc776b30.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.fourpeaks.com/8th-street-pub",
      "poi_directions_map_url": "https://maps.google.com/?cid=2634640939298464657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "four-peaks-brewing-company",
      "poi_latitude": "33.4195041",
      "poi_longitude": "-111.9158283",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 480-303-9967",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d551-752a-ac36-e6c400ca163e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d551-752a-ac36-e6c400ca163e",
        "storage_key": "property/5697689396183040/019d02f1-d551-752a-ac36-e6c400ca163e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY9M3BPAIK4cRkSOWsfkfkCQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_c44d11a380bd8b1438586fd0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Zu Izakaya - ASU",
      "poi_type": "Restaurants",
      "poi_address": "1212 E Apache Blvd #107-109, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-a11b-74da-81b1-85235a59b8ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-a11b-74da-81b1-85235a59b8ac",
        "storage_key": "property/5697689396183040/019f14fa-a11b-74da-81b1-85235a59b8ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.zuizakaya.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11467093959024384037&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zu-izakaya---asu",
      "poi_latitude": "33.4151853",
      "poi_longitude": "-111.9197067",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 480-590-2903",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d551-752a-ac36-e6c400ca163e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d551-752a-ac36-e6c400ca163e",
        "storage_key": "property/5697689396183040/019d02f1-d551-752a-ac36-e6c400ca163e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz1psK8oJK4cRJRitUTNNI58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "ec_297dfc06b33d88486d993d07",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Cocina Chiwas",
      "poi_type": "Restaurants",
      "poi_address": "2001 E Apache Blvd, Tempe, AZ 85281, USA",
      "poi_short_description": "Full-service restaurant and bar turning out Mexican food and drinks in a casual setting.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-ae4b-74a8-bae9-aa9c944f80f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-ae4b-74a8-bae9-aa9c944f80f3",
        "storage_key": "property/5697689396183040/019f14fa-ae4b-74a8-bae9-aa9c944f80f3.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://cocinachiwasaz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4225856390216510226&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cocina-chiwas",
      "poi_latitude": "33.4145411",
      "poi_longitude": "-111.9001476",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 480-916-3690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d551-752a-ac36-e6c400ca163e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d551-752a-ac36-e6c400ca163e",
        "storage_key": "property/5697689396183040/019d02f1-d551-752a-ac36-e6c400ca163e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN-I6Xl4IK4cREmurUv9BpTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_31658c6733b8b855300102c7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Blanco Cocina + Cantina",
      "poi_type": "Restaurants",
      "poi_address": "717 S Novus Pl, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-a812-77ed-9316-709c59168ad1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-a812-77ed-9316-709c59168ad1",
        "storage_key": "property/5697689396183040/019f14fa-a812-77ed-9316-709c59168ad1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.blancococinacantina.com/locations/blanco-cocina-cantina-tempe-az/?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=15361780742258863759&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blanco-cocina--cantina",
      "poi_latitude": "33.4240862",
      "poi_longitude": "-111.9267164",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 480-366-3717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc1-73c2-898f-11b4fe71092b",
        "storage_key": "property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWbvhxuAIK4cRj67G4zECMNU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_536ec420d14f74e78897c068",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Los Amigos Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1874 E Apache Blvd, Tempe, AZ 85281, USA",
      "poi_short_description": "Convenience store offering groceries, frozen foods, and money transfer services.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-a753-7600-9283-e899b8d00463.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-a753-7600-9283-e899b8d00463",
        "storage_key": "property/5697689396183040/019f14fa-a753-7600-9283-e899b8d00463.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://bit.ly/3C0UBoC",
      "poi_directions_map_url": "https://maps.google.com/?cid=5323538215355889923&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "los-amigos-market",
      "poi_latitude": "33.4150908",
      "poi_longitude": "-111.9050545",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 480-702-0118",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d543-7098-aa8c-c5132c342ffc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d543-7098-aa8c-c5132c342ffc",
        "storage_key": "property/5697689396183040/019d02f1-d543-7098-aa8c-c5132c342ffc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDQeBzeAJK4cRAzmBMs0B4Uk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_628678604b3f2beed66271a3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Don \"Filo's\" Super Carniceria",
      "poi_type": "Shopping & Retail",
      "poi_address": "1531 E Apache Blvd, Tempe, AZ 85281, USA",
      "poi_short_description": "Family-run option for Mexican groceries and prepared fare, including tacos.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-a81d-7308-9a41-315908f666fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-a81d-7308-9a41-315908f666fd",
        "storage_key": "property/5697689396183040/019f14fa-a81d-7308-9a41-315908f666fd.webp",
        "width": 1144,
        "height": 1022
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17125757491673004191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "don-filos-super-carniceria",
      "poi_latitude": "33.4143086",
      "poi_longitude": "-111.912773",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 480-966-0026",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d543-7098-aa8c-c5132c342ffc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d543-7098-aa8c-c5132c342ffc",
        "storage_key": "property/5697689396183040/019d02f1-d543-7098-aa8c-c5132c342ffc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2Qthz_MIK4cRn3in2LPpqu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_d711eabf535dd384820eebd4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "909 E Apache Blvd, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-a7c6-75af-9199-12c871ee2109.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-a7c6-75af-9199-12c871ee2109",
        "storage_key": "property/5697689396183040/019f14fa-a7c6-75af-9199-12c871ee2109.webp",
        "width": 720,
        "height": 481
      },
      "poi_business_url": "https://www.cvs.com/store-locator/tempe-az-pharmacies/909-east-apache-blvd-tempe-az-85281/storeid=10928?WT.mc_id=LS_GOOGLE_RX_10928",
      "poi_directions_map_url": "https://maps.google.com/?cid=16774801966564843269&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "33.4145245",
      "poi_longitude": "-111.9259867",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 480-967-0799",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-4aed-7656-9f2d-718eea65df87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-4aed-7656-9f2d-718eea65df87",
        "storage_key": "property/5697689396183040/019f14fb-4aed-7656-9f2d-718eea65df87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR7EapOkIK4cRBR-fCoMRzOg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_a258b2aee93259576ca067b3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Food City",
      "poi_type": "Shopping & Retail",
      "poi_address": "1338 E Apache Blvd, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-ac71-7158-8edd-3ca9c156594b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-ac71-7158-8edd-3ca9c156594b",
        "storage_key": "property/5697689396183040/019f14fa-ac71-7158-8edd-3ca9c156594b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://myfoodcity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4867986713373263740&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-city",
      "poi_latitude": "33.4153139",
      "poi_longitude": "-111.9155461",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 480-557-9301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d543-7098-aa8c-c5132c342ffc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d543-7098-aa8c-c5132c342ffc",
        "storage_key": "property/5697689396183040/019d02f1-d543-7098-aa8c-c5132c342ffc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSwIwDu4IK4cRfEfvxR-QjkM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_d3a8669f4cd4fd664695b4c0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Circle K | Gas Station",
      "poi_type": "Shopping & Retail",
      "poi_address": "2196 E Apache Blvd, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.circlek.com/store-locator/US/tempe/2196-e-apache-blvd/2708592?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=15818085000148570807&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k--gas-station",
      "poi_latitude": "33.4151098",
      "poi_longitude": "-111.892362",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 480-968-9677",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-4aeb-7149-80cd-6da1bb39ff3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-4aeb-7149-80cd-6da1bb39ff3d",
        "storage_key": "property/5697689396183040/019f14fb-4aeb-7149-80cd-6da1bb39ff3d.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9aGm92AJK4cRt1LK9H8ghds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_3892ab8b977ed109eb446eb6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Food Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "825 E Apache Blvd, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-b291-7588-b598-ed8388181c66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-b291-7588-b598-ed8388181c66",
        "storage_key": "property/5697689396183040/019f14fa-b291-7588-b598-ed8388181c66.webp",
        "width": 598,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14511813770589813789&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-mart",
      "poi_latitude": "33.4142967",
      "poi_longitude": "-111.9267619",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d541-740e-8d5e-2bdd216ad23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d541-740e-8d5e-2bdd216ad23b",
        "storage_key": "property/5697689396183040/019d02f1-d541-740e-8d5e-2bdd216ad23b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJrWL7uOkIK4cRHbygyrxRZMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_bee38321f7993b0e04d87d8c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "1800 E Rio Salado Pkwy Ste 120, Tempe, AZ 85288, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-b700-77d3-a2cb-28ee3de4b80e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-b700-77d3-a2cb-28ee3de4b80e",
        "storage_key": "property/5697689396183040/019f14fa-b700-77d3-a2cb-28ee3de4b80e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/tempe-rio-salado/2176",
      "poi_directions_map_url": "https://maps.google.com/?cid=3515733643322978100&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "33.4298757",
      "poi_longitude": "-111.9058583",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 480-214-2667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d541-740e-8d5e-2bdd216ad23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d541-740e-8d5e-2bdd216ad23b",
        "storage_key": "property/5697689396183040/019d02f1-d541-740e-8d5e-2bdd216ad23b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJeYaeYP4IK4cRNO8nFx9lyjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_27ac1c79e35475960278dd19",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "800 E Southern Ave, Tempe, AZ 85282, USA",
      "poi_short_description": "Chain department store stocking a wide selection of merchandise, including electronics, clothing, and home goods.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-b5c8-768e-8724-ac35de9da091.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-b5c8-768e-8724-ac35de9da091",
        "storage_key": "property/5697689396183040/019f14fa-b5c8-768e-8724-ac35de9da091.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://www.walmart.com/store/5768-tempe-az/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=16903455239068043439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "33.3937987",
      "poi_longitude": "-111.9278428",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 480-966-0264",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d541-740e-8d5e-2bdd216ad23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d541-740e-8d5e-2bdd216ad23b",
        "storage_key": "property/5697689396183040/019d02f1-d541-740e-8d5e-2bdd216ad23b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2ZiyfZgIK4cRr8hdSfsileo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_d94dcf6f499c7b2e7d213931",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Safeway",
      "poi_type": "Shopping & Retail",
      "poi_address": "926 E Broadway Rd, Tempe, AZ 85282, USA",
      "poi_short_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_long_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-b232-71ec-86b7-b8bdfce3ba63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-b232-71ec-86b7-b8bdfce3ba63",
        "storage_key": "property/5697689396183040/019f14fa-b232-71ec-86b7-b8bdfce3ba63.webp",
        "width": 600,
        "height": 337
      },
      "poi_business_url": "https://local.safeway.com/safeway/az/tempe/926-e-broadway-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=12512885454175154552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "safeway",
      "poi_latitude": "33.4090163",
      "poi_longitude": "-111.9251615",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 480-829-6824",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d543-7098-aa8c-c5132c342ffc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d543-7098-aa8c-c5132c342ffc",
        "storage_key": "property/5697689396183040/019d02f1-d543-7098-aa8c-c5132c342ffc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqS1nH-sIK4cReDFDQwazpq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_df37853d8e8feaa2e08df698",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Fry's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1835 E Guadalupe Rd, Tempe, AZ 85283, USA",
      "poi_short_description": "Outpost of a grocery store chain with typical offerings like produce, meat & household supplies.",
      "poi_long_description": "Outpost of a grocery store chain with typical offerings like produce, meat & household supplies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-c1cd-766f-ab58-a8b79f713e33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-c1cd-766f-ab58-a8b79f713e33",
        "storage_key": "property/5697689396183040/019f14fa-c1cd-766f-ab58-a8b79f713e33.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.frysfood.com/stores/grocery/az/tempe/mcclintock-guadalupe/660/00022?cid=loc_66000022_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=8558502655164177226&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frys",
      "poi_latitude": "33.3622508",
      "poi_longitude": "-111.9091623",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 480-838-7023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d543-7098-aa8c-c5132c342ffc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d543-7098-aa8c-c5132c342ffc",
        "storage_key": "property/5697689396183040/019d02f1-d543-7098-aa8c-c5132c342ffc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKR1DwksGK4cRSltM6tHoxXY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_79837ac75aa56935bcfb3c45",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "New School for the Arts & Academics",
      "poi_type": "Education",
      "poi_address": "1216 E Apache Blvd, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-b9a4-70e9-92c6-ebb7f3817baa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-b9a4-70e9-92c6-ebb7f3817baa",
        "storage_key": "property/5697689396183040/019f14fa-b9a4-70e9-92c6-ebb7f3817baa.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.aznsaa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15440908554542719141&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-school-for-the-arts--academics",
      "poi_latitude": "33.4152665",
      "poi_longitude": "-111.9192281",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 480-481-9235",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d550-729f-9e4d-2008ab9db0c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d550-729f-9e4d-2008ab9db0c6",
        "storage_key": "property/5697689396183040/019d02f1-d550-729f-9e4d-2008ab9db0c6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoc_uYO4IK4cRpSDPWoUgSdY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_e3f74e5153e46502c68047aa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "ASU - Tempe Campus",
      "poi_type": "Education",
      "poi_address": "1151 S Forest Ave, Tempe, AZ 85287, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-c051-700e-8194-dba9d3d628c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-c051-700e-8194-dba9d3d628c2",
        "storage_key": "property/5697689396183040/019f14fa-c051-700e-8194-dba9d3d628c2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://campus.asu.edu/tempe",
      "poi_directions_map_url": "https://maps.google.com/?cid=16422268708905604552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "asu---tempe-campus",
      "poi_latitude": "33.42166",
      "poi_longitude": "-111.9349746",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 480-965-9011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d550-729f-9e4d-2008ab9db0c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d550-729f-9e4d-2008ab9db0c6",
        "storage_key": "property/5697689396183040/019d02f1-d550-729f-9e4d-2008ab9db0c6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN0dhVNsIK4cRyNVUwGGe5-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "academic_department"
    },
    {
      "id": "ec_fd707c9a6cad201ec8ab5f5f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Tempe High School",
      "poi_type": "Education",
      "poi_address": "1730 S Mill Ave, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-ba7a-73ec-b46a-a255a1106794.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-ba7a-73ec-b46a-a255a1106794",
        "storage_key": "property/5697689396183040/019f14fa-ba7a-73ec-b46a-a255a1106794.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tempeunion.org/tempehigh",
      "poi_directions_map_url": "https://maps.google.com/?cid=12349502895841399464&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tempe-high-school",
      "poi_latitude": "33.4083769",
      "poi_longitude": "-111.9402971",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 480-967-1661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d550-729f-9e4d-2008ab9db0c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d550-729f-9e4d-2008ab9db0c6",
        "storage_key": "property/5697689396183040/019d02f1-d550-729f-9e4d-2008ab9db0c6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ555EBMYIK4cRqNJIC3Q_Yqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_82d0be15426a35178f5cf06c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Geneva Epps Mosley Middle School",
      "poi_type": "Education",
      "poi_address": "1025 S Beck Ave, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.tempeschools.org/mosley",
      "poi_directions_map_url": "https://maps.google.com/?cid=14315278547957920724&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "geneva-epps-mosley-middle-school",
      "poi_latitude": "33.4173653",
      "poi_longitude": "-111.9551307",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 480-966-7114",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d550-729f-9e4d-2008ab9db0c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d550-729f-9e4d-2008ab9db0c6",
        "storage_key": "property/5697689396183040/019d02f1-d550-729f-9e4d-2008ab9db0c6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY6L-iSsPK4cR1DPNZ_4VqsY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_a9f05c0d6fcacc0a2ca53c0e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Holdeman Elementary School",
      "poi_type": "Education",
      "poi_address": "1326 W 18th St, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-b9d6-769b-8386-cdd6b6e65575.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-b9d6-769b-8386-cdd6b6e65575",
        "storage_key": "property/5697689396183040/019f14fa-b9d6-769b-8386-cdd6b6e65575.webp",
        "width": 700,
        "height": 468
      },
      "poi_business_url": "http://www.tempeschools.org/holdeman",
      "poi_directions_map_url": "https://maps.google.com/?cid=13415980748006305779&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holdeman-elementary-school",
      "poi_latitude": "33.4099515",
      "poi_longitude": "-111.9602168",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 480-966-9934",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d550-729f-9e4d-2008ab9db0c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d550-729f-9e4d-2008ab9db0c6",
        "storage_key": "property/5697689396183040/019d02f1-d550-729f-9e4d-2008ab9db0c6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ56vHnDEPK4cR8y9lzmgjL7o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_c8654bcc3119c352082db0a2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Broadmor Elementary School",
      "poi_type": "Education",
      "poi_address": "311 E Aepli Dr, Tempe, AZ 85282, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-bd44-70f9-a458-4af8440f820d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-bd44-70f9-a458-4af8440f820d",
        "storage_key": "property/5697689396183040/019f14fa-bd44-70f9-a458-4af8440f820d.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.tempeschools.org/Broadmor",
      "poi_directions_map_url": "https://maps.google.com/?cid=12437283861122495214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broadmor-elementary-school",
      "poi_latitude": "33.4051118",
      "poi_longitude": "-111.934417",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 480-967-6599",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d550-729f-9e4d-2008ab9db0c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d550-729f-9e4d-2008ab9db0c6",
        "storage_key": "property/5697689396183040/019d02f1-d550-729f-9e4d-2008ab9db0c6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMV8yXL8IK4cR7rLnsMYbmqw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_5d7b6890b3cec003755530f1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Tempe Preparatory Academy",
      "poi_type": "Education",
      "poi_address": "1251 E Southern Ave, Tempe, AZ 85282, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-ca15-7680-9eaf-864f9804bde6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-ca15-7680-9eaf-864f9804bde6",
        "storage_key": "property/5697689396183040/019f14fa-ca15-7680-9eaf-864f9804bde6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tempeprep.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9547992349797423552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tempe-preparatory-academy",
      "poi_latitude": "33.3927802",
      "poi_longitude": "-111.9182062",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 480-839-3402",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d550-729f-9e4d-2008ab9db0c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d550-729f-9e4d-2008ab9db0c6",
        "storage_key": "property/5697689396183040/019d02f1-d550-729f-9e4d-2008ab9db0c6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAfQYg5wIK4cRwJnSZ3RIgYQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_8f23dcf5e42335429f70839c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "ASU Child Study Lab",
      "poi_type": "Education",
      "poi_address": "1st Floor, Psychology Bldg, 950 S McAllister Ave, Tempe, AZ 85287, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://psychology.asu.edu/childstudylab",
      "poi_directions_map_url": "https://maps.google.com/?cid=17646903024024206383&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "asu-child-study-lab",
      "poi_latitude": "33.4198736",
      "poi_longitude": "-111.9295509",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 480-965-5320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc1-73c2-898f-11b4fe71092b",
        "storage_key": "property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc_iDDycJK4cRL7y6lM1k5vQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_fdb04882e1dd5394aa95a49a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Rio Salado College",
      "poi_type": "Education",
      "poi_address": "2323 W 14th St, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-ca1b-73ed-a892-0351ea4445c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-ca1b-73ed-a892-0351ea4445c4",
        "storage_key": "property/5697689396183040/019f14fa-ca1b-73ed-a892-0351ea4445c4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.riosalado.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13902576961550405932&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rio-salado-college",
      "poi_latitude": "33.4128214",
      "poi_longitude": "-111.9741279",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-517-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d550-729f-9e4d-2008ab9db0c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d550-729f-9e4d-2008ab9db0c6",
        "storage_key": "property/5697689396183040/019d02f1-d550-729f-9e4d-2008ab9db0c6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5edFQIuoK4cRLNG9Zxbg78A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_ffa081c868d3a3d21015d9dd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "McClintock High School",
      "poi_type": "Education",
      "poi_address": "1830 E Del Rio Dr, Tempe, AZ 85282, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-c8f0-717c-8aa4-ac20e9207e5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-c8f0-717c-8aa4-ac20e9207e5b",
        "storage_key": "property/5697689396183040/019f14fa-c8f0-717c-8aa4-ac20e9207e5b.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://www.tempeunion.org/mcclintock",
      "poi_directions_map_url": "https://maps.google.com/?cid=1156834215075847441&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcclintock-high-school",
      "poi_latitude": "33.3968365",
      "poi_longitude": "-111.9077075",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 480-839-4222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d550-729f-9e4d-2008ab9db0c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d550-729f-9e4d-2008ab9db0c6",
        "storage_key": "property/5697689396183040/019d02f1-d550-729f-9e4d-2008ab9db0c6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrdHVpIcIK4cRER2d5ZbmDRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_fa47bf02228d06cf09b00769",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "ASU Gammage",
      "poi_type": "Entertainment",
      "poi_address": "1200 S Forest Ave, Tempe, AZ 85281, USA",
      "poi_short_description": "This historic theater on the Arizona State University campus hosts many renowned arts performances.",
      "poi_long_description": "This historic theater on the Arizona State University campus hosts many renowned arts performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-d36d-77c1-b52f-7a16ac5cd75c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-d36d-77c1-b52f-7a16ac5cd75c",
        "storage_key": "property/5697689396183040/019f14fa-d36d-77c1-b52f-7a16ac5cd75c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.asugammage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12865873774944783345&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "asu-gammage",
      "poi_latitude": "33.4162651",
      "poi_longitude": "-111.9380015",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 480-965-3434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc1-73c2-898f-11b4fe71092b",
        "storage_key": "property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZeQR0NoIK4cR8QuZMAjEjLI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_8771a5a6eb7f8ec8f3bebabc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Tempe Center For The Arts",
      "poi_type": "Entertainment",
      "poi_address": "700 W Rio Salado Pkwy, Tempe, AZ 85281, USA",
      "poi_short_description": "Big, modern art center by Tempe Town Lake with a varied performing arts schedule & a small gallery.",
      "poi_long_description": "Big, modern art center by Tempe Town Lake with a varied performing arts schedule & a small gallery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-c55a-767b-9acc-7f6d0db57e5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-c55a-767b-9acc-7f6d0db57e5e",
        "storage_key": "property/5697689396183040/019f14fa-c55a-767b-9acc-7f6d0db57e5e.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "http://www.tempe.gov/tca",
      "poi_directions_map_url": "https://maps.google.com/?cid=7261790573550833498&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tempe-center-for-the-arts",
      "poi_latitude": "33.4319",
      "poi_longitude": "-111.948896",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 480-350-2822",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc1-73c2-898f-11b4fe71092b",
        "storage_key": "property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKyddUCwJK4cRWg_HUQ0Qx2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_1b2d01e5eed1cd81bacdc16c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Marquee Theatre Tempe",
      "poi_type": "Entertainment",
      "poi_address": "730 N Mill Ave, Tempe, AZ 85288, USA",
      "poi_short_description": "Big-name bands & emerging acts showcase their tunes at this concert venue that seats 1,000.",
      "poi_long_description": "Big-name bands & emerging acts showcase their tunes at this concert venue that seats 1,000.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-edf9-76cc-a1bf-caa86d0c9dc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-edf9-76cc-a1bf-caa86d0c9dc3",
        "storage_key": "property/5697689396183040/019f14fa-edf9-76cc-a1bf-caa86d0c9dc3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://marqueetheatreaz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9588960161918623628&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marquee-theatre-tempe",
      "poi_latitude": "33.4369477",
      "poi_longitude": "-111.9439989",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 480-829-0607",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc1-73c2-898f-11b4fe71092b",
        "storage_key": "property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS0mPzjEJK4cRjB-IeHbUEoU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_c4118af0c4450d999ce5650b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Harkins Theatres Tempe Marketplace",
      "poi_type": "Entertainment",
      "poi_address": "2000 E Rio Salado Pkwy #1160, Tempe, AZ 85288, USA",
      "poi_short_description": "Modern multiplex chain showing blockbusters & a few independent films; some venues offer childcare.",
      "poi_long_description": "Modern multiplex chain showing blockbusters & a few independent films; some venues offer childcare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-cc7c-70fc-9a39-6867032c9362.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-cc7c-70fc-9a39-6867032c9362",
        "storage_key": "property/5697689396183040/019f14fa-cc7c-70fc-9a39-6867032c9362.webp",
        "width": 1280,
        "height": 1006
      },
      "poi_business_url": "https://harkins.com/theatres/tempe-marketplace?utm_source=google_listing&utm_medium=web&utm_campaign=gmb&utm_id=local_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=11622965373960455456&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harkins-theatres-tempe-marketplace",
      "poi_latitude": "33.4339673",
      "poi_longitude": "-111.9014728",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 480-557-0027",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-4aff-729e-bf9a-36ecf47e5c24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-4aff-729e-bf9a-36ecf47e5c24",
        "storage_key": "property/5697689396183040/019f14fb-4aff-729e-bf9a-36ecf47e5c24.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJq3vqPlQIK4cRIAWUL20RTaE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_60f9d0461b8c312024c69a90",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Tempe Marketplace",
      "poi_type": "Entertainment",
      "poi_address": "2000 E Rio Salado Pkwy, Tempe, AZ 85288, USA",
      "poi_short_description": "Outdoor mall with national retailers, dining, live music on weekends & a play fountain for kids.",
      "poi_long_description": "Outdoor mall with national retailers, dining, live music on weekends & a play fountain for kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-817f-75ed-87db-7eddc75401fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f1-817f-75ed-87db-7eddc75401fa",
        "storage_key": "property/5697689396183040/019d02f1-817f-75ed-87db-7eddc75401fa.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tempemarketplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16874235038211004953&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tempe-marketplace",
      "poi_latitude": "33.4340695",
      "poi_longitude": "-111.9012791",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 480-966-9338",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d541-740e-8d5e-2bdd216ad23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d541-740e-8d5e-2bdd216ad23b",
        "storage_key": "property/5697689396183040/019d02f1-d541-740e-8d5e-2bdd216ad23b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJz3KubQsJK4cRGVoEHV1TLeo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_3fcbae6ad6c09a4d7a289720",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Mill Avenue Shops",
      "poi_type": "Entertainment",
      "poi_address": "414 S Mill Ave #114, Tempe, AZ 85281, USA",
      "poi_short_description": "Collection of shops, restaurants, and bars set within the Courtyard Shops complex.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-da39-71c1-90f7-f198efac5eb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-da39-71c1-90f7-f198efac5eb6",
        "storage_key": "property/5697689396183040/019f14fa-da39-71c1-90f7-f198efac5eb6.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7233823357341734034&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mill-avenue-shops",
      "poi_latitude": "33.4259647",
      "poi_longitude": "-111.9402513",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d541-740e-8d5e-2bdd216ad23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d541-740e-8d5e-2bdd216ad23b",
        "storage_key": "property/5697689396183040/019d02f1-d541-740e-8d5e-2bdd216ad23b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJD83L8HwJK4cRkhRHXgS0Y2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_dd1b0f443a75fa17a945b996",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Tempe Beach Park",
      "poi_type": "Entertainment",
      "poi_address": "80 W Rio Salado Pkwy, Tempe, AZ 85281, USA",
      "poi_short_description": "Local landmark features a splash playground, boating, a baseball diamond & other athletic fields.",
      "poi_long_description": "Local landmark features a splash playground, boating, a baseball diamond & other athletic fields.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-b7b5-75ea-bc5c-7ba206120481.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f1-b7b5-75ea-bc5c-7ba206120481",
        "storage_key": "property/5697689396183040/019d02f1-b7b5-75ea-bc5c-7ba206120481.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tempe.gov/Home/Components/FacilityDirectory/FacilityDirectory/176/3542",
      "poi_directions_map_url": "https://maps.google.com/?cid=366973538302800349&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tempe-beach-park",
      "poi_latitude": "33.4318454",
      "poi_longitude": "-111.9426228",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 480-350-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-e071-778c-b8ad-f13a2b867995.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-e071-778c-b8ad-f13a2b867995",
        "storage_key": "property/5697689396183040/019d02f1-e071-778c-b8ad-f13a2b867995.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3XPvtSgJK4cR3bGBIH3AFwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_1907237c85587589f106e7df",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "LEGOLAND Discovery Center Arizona",
      "poi_type": "Entertainment",
      "poi_address": "5000 S Arizona Mills Cir Ste 135, Tempe, AZ 85282, USA",
      "poi_short_description": "Upbeat amusement center featuring family-friendly exhibits, 4D movies, rides & a Lego factory tour.",
      "poi_long_description": "Upbeat amusement center featuring family-friendly exhibits, 4D movies, rides & a Lego factory tour.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-d766-754f-ab22-de780cf6023a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-d766-754f-ab22-de780cf6023a",
        "storage_key": "property/5697689396183040/019f14fa-d766-754f-ab22-de780cf6023a.webp",
        "width": 600,
        "height": 411
      },
      "poi_business_url": "https://www.legolanddiscoverycenter.com/arizona/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=9103573918068574278&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legoland-discovery-center-arizona",
      "poi_latitude": "33.3856183",
      "poi_longitude": "-111.9634524",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 480-565-7081",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc1-73c2-898f-11b4fe71092b",
        "storage_key": "property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzRgr5FkPK4cRRgj95D5kVn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_af6b94625518146ce527657d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "SEA LIFE Arizona Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "5000 S Arizona Mills Cir Ste 145, Tempe, AZ 85282, USA",
      "poi_short_description": "Family-friendly exhibits with a variety of sea creatures (most offer play areas & group packages).",
      "poi_long_description": "Family-friendly exhibits with a variety of sea creatures (most offer play areas & group packages).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-d75b-7208-a15e-6ec72f578bc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-d75b-7208-a15e-6ec72f578bc4",
        "storage_key": "property/5697689396183040/019f14fa-d75b-7208-a15e-6ec72f578bc4.webp",
        "width": 960,
        "height": 639
      },
      "poi_business_url": "https://www.visitsealife.com/arizona/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=5764640459261859178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sea-life-arizona-aquarium",
      "poi_latitude": "33.38481",
      "poi_longitude": "-111.9633344",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 480-565-7072",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc1-73c2-898f-11b4fe71092b",
        "storage_key": "property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5Qh3DFoPK4cRatUlkPQdAFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "ec_3e9769e0ae3ecfdcb44a9d86",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Tempe History Museum",
      "poi_type": "Entertainment",
      "poi_address": "809 E Southern Ave, Tempe, AZ 85282, USA",
      "poi_short_description": "Roomy museum highlighting Tempe's growth over the years, including via rotating displays & orations.",
      "poi_long_description": "Roomy museum highlighting Tempe's growth over the years, including via rotating displays & orations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-e3d4-75f0-b73e-b0639d834e53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-e3d4-75f0-b73e-b0639d834e53",
        "storage_key": "property/5697689396183040/019f14fa-e3d4-75f0-b73e-b0639d834e53.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tempe.gov/government/community-services/tempe-history-museum",
      "poi_directions_map_url": "https://maps.google.com/?cid=1373498854036887627&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tempe-history-museum",
      "poi_latitude": "33.3920862",
      "poi_longitude": "-111.9274687",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 480-350-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc2-752a-9be2-5611e1e10772.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc2-752a-9be2-5611e1e10772",
        "storage_key": "property/5697689396183040/019d02f1-dbc2-752a-9be2-5611e1e10772.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ1fr6pgIK4cRS1hGPu6lDxM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_26b1f5030cc4dbd92b642191",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "HonorHealth Tempe Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1500 S Mill Ave, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-d9b5-7706-bfd0-b7e7182a45b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-d9b5-7706-bfd0-b7e7182a45b5",
        "storage_key": "property/5697689396183040/019f14fa-d9b5-7706-bfd0-b7e7182a45b5.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.honorhealth.com/locations/hospitals/tempe-medical-center?utm_source=yext&utm_medium=local&utm_campaign=medicalcenter_tempe",
      "poi_directions_map_url": "https://maps.google.com/?cid=4444380373637716218&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "honorhealth-tempe-medical-center",
      "poi_latitude": "33.4123423",
      "poi_longitude": "-111.9406127",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 480-784-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-e06d-77c0-a265-c1ba9487ed07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-e06d-77c0-a265-c1ba9487ed07",
        "storage_key": "property/5697689396183040/019d02f1-e06d-77c0-a265-c1ba9487ed07.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ64hRds8IK4cR-thkCWecrT0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_470184169be8a40693712d68",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "HonorHealth Urgent Care - Tempe - ASU",
      "poi_type": "Health and Wellness",
      "poi_address": "725 S Rural Rd Ste 120, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-e3d4-75f0-b73e-b463e6543b61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-e3d4-75f0-b73e-b463e6543b61",
        "storage_key": "property/5697689396183040/019f14fa-e3d4-75f0-b73e-b463e6543b61.webp",
        "width": 1280,
        "height": 686
      },
      "poi_business_url": "https://www.honorhealth.com/locations/urgent-care/honorhealth-urgent-care-tempe-asu",
      "poi_directions_map_url": "https://maps.google.com/?cid=1288899840140136587&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "honorhealth-urgent-care---tempe---asu",
      "poi_latitude": "33.4228352",
      "poi_longitude": "-111.9257875",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 480-214-0622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc1-73c2-898f-11b4fe71092b",
        "storage_key": "property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHdIY5-YIK4cRi1CcYpMX4xE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_2b6af20f0df345baf7d27b68",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "MinuteClinic at CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "909 E Apache Blvd, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-e007-77ed-898a-d3a146c69d7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-e007-77ed-898a-d3a146c69d7d",
        "storage_key": "property/5697689396183040/019f14fa-e007-77ed-898a-d3a146c69d7d.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.cvs.com/minuteclinic/clinic-locator/az/tempe/10928.html?WT.mc_id=LS_mc_google_carenav_10928",
      "poi_directions_map_url": "https://maps.google.com/?cid=16894210470609840703&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "minuteclinic-at-cvs",
      "poi_latitude": "33.4145483",
      "poi_longitude": "-111.9260228",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 866-389-2727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc1-73c2-898f-11b4fe71092b",
        "storage_key": "property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW21JQw8JK4cRP2pi5elKdOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_26f941b0ea9a58e80f3dd68d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "2000 S Mill Ave, Tempe, AZ 85282, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-e7c0-71fe-8059-1e41978f244d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-e7c0-71fe-8059-1e41978f244d",
        "storage_key": "property/5697689396183040/019f14fa-e7c0-71fe-8059-1e41978f244d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2000+s+mill+ave-tempe-az-85282/id=11610",
      "poi_directions_map_url": "https://maps.google.com/?cid=13532801848289348130&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "33.4068817",
      "poi_longitude": "-111.9404177",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 480-921-8013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc1-73c2-898f-11b4fe71092b",
        "storage_key": "property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpfmEeMgIK4cRIkoJx5Qrzrs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_4fd39ddb132739af309916b1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "The Access",
      "poi_type": "Health and Wellness",
      "poi_address": "1811 E Apache Blvd, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-2246-721f-93dc-68e59015fbff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f1-2246-721f-93dc-68e59015fbff",
        "storage_key": "property/5697689396183040/019d02f1-2246-721f-93dc-68e59015fbff.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.liveattheaccess.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17233809891587521706&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-access",
      "poi_latitude": "33.4137034",
      "poi_longitude": "-111.9076965",
      "poi_miles_from_property": "266 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 520-346-7716",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc1-73c2-898f-11b4fe71092b",
        "storage_key": "property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPYD-rR4JK4cRqvyvqsnKKu8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "apartment_complex"
    },
    {
      "id": "ec_613af4f1fea29dc026c47994",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "HOTWORX - Tempe, AZ - Tempe Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "1135 E Apache Blvd Ste 105, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-e0c3-7299-b17c-bc6dd3ca5668.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-e0c3-7299-b17c-bc6dd3ca5668",
        "storage_key": "property/5697689396183040/019f14fa-e0c3-7299-b17c-bc6dd3ca5668.webp",
        "width": 554,
        "height": 312
      },
      "poi_business_url": "https://www.hotworx.net/studio/tempecampus?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=5265704107733593014&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx---tempe-az---tempe-campus",
      "poi_latitude": "33.414315",
      "poi_longitude": "-111.920793",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 602-609-4328",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d550-729f-9e4d-2008ab9db0c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d550-729f-9e4d-2008ab9db0c6",
        "storage_key": "property/5697689396183040/019d02f1-d550-729f-9e4d-2008ab9db0c6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM-MU2d0JK4cRtqvGsfyJE0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_e8898eab6196101bd2dbd70c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Sun Devil Fitness Complex",
      "poi_type": "Health and Wellness",
      "poi_address": "400 E Apache Blvd, Tempe, AZ 85281, USA",
      "poi_short_description": "Large, student-serving fitness center featuring a wide range of equipment and courts, plus an outdoor pool.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-eda9-73e8-934f-1121ee29bc27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-eda9-73e8-934f-1121ee29bc27",
        "storage_key": "property/5697689396183040/019f14fa-eda9-73e8-934f-1121ee29bc27.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://fitness.asu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13523818065026639682&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sun-devil-fitness-complex",
      "poi_latitude": "33.4152209",
      "poi_longitude": "-111.932521",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 480-727-7802",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc1-73c2-898f-11b4fe71092b",
        "storage_key": "property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm0cHEsMIK4cRQmfsvOBArrs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_9107f51f43f9631fab072391",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Arizona Yoga Co.",
      "poi_type": "Health and Wellness",
      "poi_address": "414 S Mill Ave Ste B102, Tempe, AZ 85281, USA",
      "poi_short_description": "Studio offering yoga classes, including workshops, for students of various levels.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-f4f9-75ab-80a6-c341243fef3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-f4f9-75ab-80a6-c341243fef3c",
        "storage_key": "property/5697689396183040/019f14fa-f4f9-75ab-80a6-c341243fef3c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.arizonayogaco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11287538047933601452&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arizona-yoga-co",
      "poi_latitude": "33.4259647",
      "poi_longitude": "-111.9402513",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-719-0019",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d550-729f-9e4d-2008ab9db0c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d550-729f-9e4d-2008ab9db0c6",
        "storage_key": "property/5697689396183040/019d02f1-d550-729f-9e4d-2008ab9db0c6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg4Eg3DwJK4cRrNbJ9wxkpZw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_9b65835dc67ee0ea4667a134",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "University Health Walk-In Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "928 S Mill Ave, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-f6a4-7113-b92a-cb61c78c6c33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-f6a4-7113-b92a-cb61c78c6c33",
        "storage_key": "property/5697689396183040/019f14fa-f6a4-7113-b92a-cb61c78c6c33.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sites.google.com/view/universityhealthclinic/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=8516758706793334833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-health-walk-in-clinic",
      "poi_latitude": "33.4197727",
      "poi_longitude": "-111.9403021",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 480-450-7707",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc1-73c2-898f-11b4fe71092b",
        "storage_key": "property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfRxKI5gJK4cRMcghjOuaMXY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_924c01012eb9bca8fe176ee2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "NextCare Urgent Care, Tempe (N Scottsdale Rd)",
      "poi_type": "Health and Wellness",
      "poi_address": "914 N Scottsdale Rd #104, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-e95b-7152-a2e4-bf9e1d2e01df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-e95b-7152-a2e4-bf9e1d2e01df",
        "storage_key": "property/5697689396183040/019f14fa-e95b-7152-a2e4-bf9e1d2e01df.webp",
        "width": 581,
        "height": 374
      },
      "poi_business_url": "https://nextcare.com/locations/az/tempe-nextcare-urgent-care-clinic/?utm_source=google&utm_medium=organic&utm_campaign=google_maps&utm_content=tempe",
      "poi_directions_map_url": "https://maps.google.com/?cid=6874324211162783067&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nextcare-urgent-care-tempe-n-scottsdale-rd",
      "poi_latitude": "33.43962250000001",
      "poi_longitude": "-111.9268381",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 480-931-3092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc1-73c2-898f-11b4fe71092b",
        "storage_key": "property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJveCpiRcJK4cRW505xXKBZl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_a48962ee1f2502301e1de6f0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Tempe Beach Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "80 W Rio Salado Pkwy, Tempe, AZ 85281, USA",
      "poi_short_description": "Local landmark features a splash playground, boating, a baseball diamond & other athletic fields.",
      "poi_long_description": "Local landmark features a splash playground, boating, a baseball diamond & other athletic fields.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-b7b5-75ea-bc5c-7ba206120481.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f1-b7b5-75ea-bc5c-7ba206120481",
        "storage_key": "property/5697689396183040/019d02f1-b7b5-75ea-bc5c-7ba206120481.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tempe.gov/Home/Components/FacilityDirectory/FacilityDirectory/176/3542",
      "poi_directions_map_url": "https://maps.google.com/?cid=366973538302800349&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tempe-beach-park",
      "poi_latitude": "33.4318454",
      "poi_longitude": "-111.9426228",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 480-350-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-e071-778c-b8ad-f13a2b867995.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-e071-778c-b8ad-f13a2b867995",
        "storage_key": "property/5697689396183040/019d02f1-e071-778c-b8ad-f13a2b867995.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3XPvtSgJK4cR3bGBIH3AFwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_4e76f42e46608564a99a5520",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Hayden Butte",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "E Rio Salado Pkwy & S Mill Ave, 201 S Packard Dr, Tempe, AZ 85281, USA",
      "poi_short_description": "Park & popular hiking area, known for a 60-ft. letter \"A\" representing Arizona State University.",
      "poi_long_description": "Park & popular hiking area, known for a 60-ft. letter \"A\" representing Arizona State University.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-f46b-7173-930b-881a40e6751a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-f46b-7173-930b-881a40e6751a",
        "storage_key": "property/5697689396183040/019f14fa-f46b-7173-930b-881a40e6751a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tempe.gov/government/community-services/tempe-history-museum/history-and-research/hayden-butte-preserve-park-a-mountain",
      "poi_directions_map_url": "https://maps.google.com/?cid=17432062841379472460&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hayden-butte",
      "poi_latitude": "33.4282413",
      "poi_longitude": "-111.9363069",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 480-350-4311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc1-73c2-898f-11b4fe71092b",
        "storage_key": "property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlbOtbCcJK4cRTMS1kssg6_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_ff97e26c0381c9e4c4f23db4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Palm Walk",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "ASU Campus, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-02b7-73ca-b1bc-5149c032e1af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-02b7-73ca-b1bc-5149c032e1af",
        "storage_key": "property/5697689396183040/019f14fb-02b7-73ca-b1bc-5149c032e1af.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1923022767207735309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "palm-walk",
      "poi_latitude": "33.4183442",
      "poi_longitude": "-111.9327049",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc1-73c2-898f-11b4fe71092b",
        "storage_key": "property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnQoTdXsJK4cRDeBnpgTzrxo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "ec_6cf5685dcf78c70086f1533e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Arizona State University Desert Arboretum Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "556 S Packard Dr, Tempe, AZ 85281, USA",
      "poi_short_description": "University campus botanical gardens on 2.5-acres with desert plants, an amphitheater & dining area.",
      "poi_long_description": "University campus botanical gardens on 2.5-acres with desert plants, an amphitheater & dining area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-fd47-75e9-b510-3901222bdc7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-fd47-75e9-b510-3901222bdc7f",
        "storage_key": "property/5697689396183040/019f14fa-fd47-75e9-b510-3901222bdc7f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://tours.asu.edu/tempe/desert-arboretum-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=15746283860500692873&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arizona-state-university-desert-arboretum-park",
      "poi_latitude": "33.425937",
      "poi_longitude": "-111.9308486",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 480-268-4165",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-e071-778c-b8ad-f13a2b867995.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-e071-778c-b8ad-f13a2b867995",
        "storage_key": "property/5697689396183040/019d02f1-e071-778c-b8ad-f13a2b867995.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJa3EutN8IK4cRiT-cZb4Jhto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_513e2167c011748340d9c513",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Mitchell Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "900 S Mitchell Dr, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-0840-718f-afb5-2f8ca231751e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-0840-718f-afb5-2f8ca231751e",
        "storage_key": "property/5697689396183040/019f14fb-0840-718f-afb5-2f8ca231751e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16684149079999539646&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mitchell-park",
      "poi_latitude": "33.4207495",
      "poi_longitude": "-111.9483064",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-e071-778c-b8ad-f13a2b867995.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-e071-778c-b8ad-f13a2b867995",
        "storage_key": "property/5697689396183040/019d02f1-e071-778c-b8ad-f13a2b867995.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJtxRVnwwJK4cRvmkIHTEBiuc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_22cf1c379ae33f50f644cd30",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Kiwanis Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Mill Ave. and, S All America Way, Tempe, AZ 85283, USA",
      "poi_short_description": "Park with a lake & a 54,000-sq.-ft. complex with an indoor wave pool & a 15-court tennis center.",
      "poi_long_description": "Park with a lake & a 54,000-sq.-ft. complex with an indoor wave pool & a 15-court tennis center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-fc23-7449-a57f-3fdddb7a831f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-fc23-7449-a57f-3fdddb7a831f",
        "storage_key": "property/5697689396183040/019f14fa-fc23-7449-a57f-3fdddb7a831f.webp",
        "width": 979,
        "height": 680
      },
      "poi_business_url": "https://www.tempe.gov/Home/Components/FacilityDirectory/FacilityDirectory/120/3542?npage=2",
      "poi_directions_map_url": "https://maps.google.com/?cid=13961563785378829176&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kiwanis-park",
      "poi_latitude": "33.3718923",
      "poi_longitude": "-111.9391798",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-350-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-e071-778c-b8ad-f13a2b867995.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-e071-778c-b8ad-f13a2b867995",
        "storage_key": "property/5697689396183040/019d02f1-e071-778c-b8ad-f13a2b867995.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJx6LURxAGK4cReJN2kEpwwcE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c80bbf7db9f34319efeb71e8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Rio Salado Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "80 W Rio Salado Pkwy, Tempe, AZ 85281, USA",
      "poi_short_description": "This former industrial area is now a desert river habitat with hiking trails & 200+ bird species.",
      "poi_long_description": "This former industrial area is now a desert river habitat with hiking trails & 200+ bird species.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-0f52-7742-9c49-0abe4d5cdb48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-0f52-7742-9c49-0abe4d5cdb48",
        "storage_key": "property/5697689396183040/019f14fb-0f52-7742-9c49-0abe4d5cdb48.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tempe.gov/government/community-services/parks/rio-salado-and-beach-park-master-plan",
      "poi_directions_map_url": "https://maps.google.com/?cid=15766292091279604764&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rio-salado-park",
      "poi_latitude": "33.4311501",
      "poi_longitude": "-111.940979",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 480-350-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-e071-778c-b8ad-f13a2b867995.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-e071-778c-b8ad-f13a2b867995",
        "storage_key": "property/5697689396183040/019d02f1-e071-778c-b8ad-f13a2b867995.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7UBrX9IOK4cRHHzFpR8fzdo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_11642c945c64b3ca200b44a7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Jaycee Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "817 W 5th St, Tempe, AZ 85281, USA",
      "poi_short_description": "City park offering athletic fields, a playground, a dog run, a community center & a parking lot.",
      "poi_long_description": "City park offering athletic fields, a playground, a dog run, a community center & a parking lot.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-0af4-769f-b33c-00ca32d7c03b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-0af4-769f-b33c-00ca32d7c03b",
        "storage_key": "property/5697689396183040/019f14fb-0af4-769f-b33c-00ca32d7c03b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://placemaking.pps.org/great_public_spaces/one?public_place_id=569&type_id=14",
      "poi_directions_map_url": "https://maps.google.com/?cid=8505057355124237394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jaycee-park",
      "poi_latitude": "33.4249051",
      "poi_longitude": "-111.9502269",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 480-350-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-e071-778c-b8ad-f13a2b867995.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-e071-778c-b8ad-f13a2b867995",
        "storage_key": "property/5697689396183040/019d02f1-e071-778c-b8ad-f13a2b867995.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvbKulyoJK4cRUuSATpoICHY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_908639477c04e7a1b92640d2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Cole Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2000 E Carson Dr, Tempe, AZ 85282, USA",
      "poi_short_description": "Park providing a playground, picnic facilities, and a lake, plus access to the Flyover Bridge.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-150b-74c8-bca0-51a1642f56e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-150b-74c8-bca0-51a1642f56e8",
        "storage_key": "property/5697689396183040/019f14fb-150b-74c8-bca0-51a1642f56e8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tempe.gov/Home/Components/FacilityDirectory/FacilityDirectory/26/3542",
      "poi_directions_map_url": "https://maps.google.com/?cid=4041495631169080999&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cole-park",
      "poi_latitude": "33.3848687",
      "poi_longitude": "-111.9012047",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 480-350-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-e071-778c-b8ad-f13a2b867995.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-e071-778c-b8ad-f13a2b867995",
        "storage_key": "property/5697689396183040/019d02f1-e071-778c-b8ad-f13a2b867995.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgUBNgtMHK4cRp04gId1GFjg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_fa32211080ba3f92a7f077bc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Hole in the Rock",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "625 N Galvin Pkwy, Phoenix, AZ 85008, USA",
      "poi_short_description": "Landmark rock formation with multiple cavelike holes in the sandstone created by erosion.",
      "poi_long_description": "Landmark rock formation with multiple cavelike holes in the sandstone created by erosion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14f7-c450-735f-bef2-de51d1aace01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-c450-735f-bef2-de51d1aace01",
        "storage_key": "property/5697689396183040/019f14f7-c450-735f-bef2-de51d1aace01.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/parks/trails/locations/papago-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=385298564104506413&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hole-in-the-rock",
      "poi_latitude": "33.4564869",
      "poi_longitude": "-111.9452606",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 602-495-5458",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc1-73c2-898f-11b4fe71092b",
        "storage_key": "property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdWuhyFEJK4cRLczqrQDbWAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_e4667340120b7f54fde83531",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "McClintock Dr & Apache Blvd Park and Ride Garage",
      "poi_type": "Transportation & Transit",
      "poi_address": "1811 E Apache Blvd, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-1322-762b-8667-5df2a062b337.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-1322-762b-8667-5df2a062b337",
        "storage_key": "property/5697689396183040/019f14fb-1322-762b-8667-5df2a062b337.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.valleymetro.org/how-to-ride/park-and-ride/mcclintock-dr-apache-blvd-park-and-ride/1811-e-apache-blvd",
      "poi_directions_map_url": "https://maps.google.com/?cid=14301739635671362131&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcclintock-dr--apache-blvd-park-and-ride-garage",
      "poi_latitude": "33.413742",
      "poi_longitude": "-111.9089112",
      "poi_miles_from_property": "459 ft",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 602-253-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-4b0a-747a-b190-cde5a603d03b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-4b0a-747a-b190-cde5a603d03b",
        "storage_key": "property/5697689396183040/019f14fb-4b0a-747a-b190-cde5a603d03b.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJGaQ-tfUIK4cRU-pQvmz8ecY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_13c4522fd1af0ecfa955592b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "McClintock/Apache Blvd",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-1c10-730a-a14a-c7b875ab02a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-1c10-730a-a14a-c7b875ab02a2",
        "storage_key": "property/5697689396183040/019f14fb-1c10-730a-a14a-c7b875ab02a2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13252773368337084250&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcclintockapache-blvd",
      "poi_latitude": "33.4147381",
      "poi_longitude": "-111.9082666",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc1-73c2-898f-11b4fe71092b",
        "storage_key": "property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV59aPvQIK4cRWi99jClP67c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_9a306c115ebdbde7c93c00e4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Price-101 Freeway/Apache Blvd Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "2235 E Apache Blvd, Tempe, AZ 85288, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-13f8-730e-b84a-6bad3f0d1df3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-13f8-730e-b84a-6bad3f0d1df3",
        "storage_key": "property/5697689396183040/019f14fb-13f8-730e-b84a-6bad3f0d1df3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.valleymetro.org/how-to-ride/park-and-ride",
      "poi_directions_map_url": "https://maps.google.com/?cid=13454526913209354012&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "price-101-freewayapache-blvd-park--ride",
      "poi_latitude": "33.4146192",
      "poi_longitude": "-111.8890166",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 602-253-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-4b0a-747a-b190-cde5a603d03b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-4b0a-747a-b190-cde5a603d03b",
        "storage_key": "property/5697689396183040/019f14fb-4b0a-747a-b190-cde5a603d03b.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJQxHX1GkIK4cRHMfGQvEUuLo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_53fe194abea5c1c88e2f14f7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Dorsey Ln/Apache Blvd",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-1eeb-7466-b192-680a77812f4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-1eeb-7466-b192-680a77812f4f",
        "storage_key": "property/5697689396183040/019f14fb-1eeb-7466-b192-680a77812f4f.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13215672625481361333&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dorsey-lnapache-blvd",
      "poi_latitude": "33.414769",
      "poi_longitude": "-111.916907",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc1-73c2-898f-11b4fe71092b",
        "storage_key": "property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR3tuBO4IK4cRtaertTuAZ7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_0e08f6088c45800e84d92b27",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Mill Ave/3rd St",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-24a4-72ca-b47d-70b8d81b2fcd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-24a4-72ca-b47d-70b8d81b2fcd",
        "storage_key": "property/5697689396183040/019f14fb-24a4-72ca-b47d-70b8d81b2fcd.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=639866828117951134&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mill-ave3rd-st",
      "poi_latitude": "33.427453",
      "poi_longitude": "-111.9406986",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc1-73c2-898f-11b4fe71092b",
        "storage_key": "property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPes7bCgJK4cRnsKGcX1D4Qg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_2059ee08c0e1b7a44bfd13b3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Tempe Transportation Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "200 E 5th St, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-2399-7288-8eef-00b7bce831cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-2399-7288-8eef-00b7bce831cf",
        "storage_key": "property/5697689396183040/019f14fb-2399-7288-8eef-00b7bce831cf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tempe.gov/government/engineering-and-transportation/transportation",
      "poi_directions_map_url": "https://maps.google.com/?cid=9749899852196634873&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tempe-transportation-center",
      "poi_latitude": "33.4259451",
      "poi_longitude": "-111.9367275",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 602-253-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc4-71b0-8ce2-1ae8c05c53ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc4-71b0-8ce2-1ae8c05c53ed",
        "storage_key": "property/5697689396183040/019d02f1-dbc4-71b0-8ce2-1ae8c05c53ed.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC6cP19gIK4cR-WDQJUKaToc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "ec_cd584ec4368a3b817c9ee467",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Hayden Ferry/Rio Salado",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-3001-7634-89c0-709b2baef5f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-3001-7634-89c0-709b2baef5f2",
        "storage_key": "property/5697689396183040/019f14fb-3001-7634-89c0-709b2baef5f2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7319813144075485025&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hayden-ferryrio-salado",
      "poi_latitude": "33.4301247",
      "poi_longitude": "-111.9381735",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc1-73c2-898f-11b4fe71092b",
        "storage_key": "property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcf9AQyYJK4cRYb_awkUzlWU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_0e80257d5b6b3e236ac2ffaf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Price-101 Freeway/Apache Blvd Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "2235 E Apache Blvd, Tempe, AZ 85288, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-13f8-730e-b84a-6bad3f0d1df3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-13f8-730e-b84a-6bad3f0d1df3",
        "storage_key": "property/5697689396183040/019f14fb-13f8-730e-b84a-6bad3f0d1df3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.valleymetro.org/how-to-ride/park-and-ride",
      "poi_directions_map_url": "https://maps.google.com/?cid=13454526913209354012&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "price-101-freewayapache-blvd-park--ride",
      "poi_latitude": "33.4146192",
      "poi_longitude": "-111.8890166",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 602-253-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-4b0a-747a-b190-cde5a603d03b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-4b0a-747a-b190-cde5a603d03b",
        "storage_key": "property/5697689396183040/019f14fb-4b0a-747a-b190-cde5a603d03b.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJQxHX1GkIK4cRHMfGQvEUuLo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_962251e29f625633301f543b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Phoenix Sky Harbor International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3400 Sky Hbr Blvd, Phoenix, AZ 85034, USA",
      "poi_short_description": "This 3,000-acre airport serving the Phoenix area  features rail service & a variety of artwork.",
      "poi_long_description": "This 3,000-acre airport serving the Phoenix area  features rail service & a variety of artwork.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14f7-ba1d-7704-9137-3a7a09b79c99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-ba1d-7704-9137-3a7a09b79c99",
        "storage_key": "property/5697689396183040/019f14f7-ba1d-7704-9137-3a7a09b79c99.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.skyharbor.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9436507786966396482&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phoenix-sky-harbor-international-airport",
      "poi_latitude": "33.435249",
      "poi_longitude": "-112.010124",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 602-273-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-e06f-73ca-bbba-c82068aa6da4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-e06f-73ca-bbba-c82068aa6da4",
        "storage_key": "property/5697689396183040/019d02f1-e06f-73ca-bbba-c82068aa6da4.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpXADM1wOK4cRQu5W4tU19YI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_fc3308d3939d10a373b94088",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "ASU - Tempe Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1151 S Forest Ave, Tempe, AZ 85287, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fa-c051-700e-8194-dba9d3d628c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fa-c051-700e-8194-dba9d3d628c2",
        "storage_key": "property/5697689396183040/019f14fa-c051-700e-8194-dba9d3d628c2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://campus.asu.edu/tempe",
      "poi_directions_map_url": "https://maps.google.com/?cid=16422268708905604552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "asu---tempe-campus",
      "poi_latitude": "33.42166",
      "poi_longitude": "-111.9349746",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 480-965-9011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d550-729f-9e4d-2008ab9db0c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d550-729f-9e4d-2008ab9db0c6",
        "storage_key": "property/5697689396183040/019d02f1-d550-729f-9e4d-2008ab9db0c6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN0dhVNsIK4cRyNVUwGGe5-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "academic_department"
    },
    {
      "id": "ec_203241964cf5790a47f7f8a3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Salt River Project",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1500 N Mill Ave, Tempe, AZ 85288, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-3836-70fe-96cc-da85ab745a7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-3836-70fe-96cc-da85ab745a7a",
        "storage_key": "property/5697689396183040/019f14fb-3836-70fe-96cc-da85ab745a7a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.srpnet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17884516187771630722&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "salt-river-project",
      "poi_latitude": "33.446293",
      "poi_longitude": "-111.9511442",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 602-236-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc1-73c2-898f-11b4fe71092b",
        "storage_key": "property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_V1UEA0OK4cRgvTZb7eQMvg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_0cf2e09dbbd6cab4a9f8b821",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Carvana Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 E Rio Salado Pkwy, Tempe, AZ 85281, USA",
      "poi_short_description": "Used-car seller, offering an online trade-in process and delivery service.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-3464-76a0-8182-0180dbd9f44d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-3464-76a0-8182-0180dbd9f44d",
        "storage_key": "property/5697689396183040/019f14fb-3464-76a0-8182-0180dbd9f44d.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://www.carvana.com/?utm_source=google&utm_medium=gmb&utm_campaign=gmb-home",
      "poi_directions_map_url": "https://maps.google.com/?cid=16470815309955343288&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carvana-headquarters",
      "poi_latitude": "33.4306086",
      "poi_longitude": "-111.9339516",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-333-4554",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d541-740e-8d5e-2bdd216ad23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d541-740e-8d5e-2bdd216ad23b",
        "storage_key": "property/5697689396183040/019d02f1-d541-740e-8d5e-2bdd216ad23b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8acU0cQOK4cRuCP0HkIXlOQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "car_dealer"
    },
    {
      "id": "ec_66bd0011e13a632df2c28a45",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "DriveTime Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1720 W Rio Salado Pkwy, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-41ed-7199-94a5-9050c9561624.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-41ed-7199-94a5-9050c9561624",
        "storage_key": "property/5697689396183040/019f14fb-41ed-7199-94a5-9050c9561624.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.drivetime.com/?reg=phx&source=local&vend=google&camn=10505",
      "poi_directions_map_url": "https://maps.google.com/?cid=7747298986830945806&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "drivetime-corporate-office",
      "poi_latitude": "33.4308812",
      "poi_longitude": "-111.9638933",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 888-418-1212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-d541-740e-8d5e-2bdd216ad23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-d541-740e-8d5e-2bdd216ad23b",
        "storage_key": "property/5697689396183040/019d02f1-d541-740e-8d5e-2bdd216ad23b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQTGd41MMK4cRDl7NrmHvg2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "car_dealer"
    },
    {
      "id": "ec_04cfbe0da2d048fb9587adcb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "GoDaddy",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 S Mill Ave Ste 1600, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-363c-75f0-88a1-c68148331aa6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-363c-75f0-88a1-c68148331aa6",
        "storage_key": "property/5697689396183040/019f14fb-363c-75f0-88a1-c68148331aa6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.godaddy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=91605267010453290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "godaddy",
      "poi_latitude": "33.4291761",
      "poi_longitude": "-111.9406592",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 480-505-8877",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc1-73c2-898f-11b4fe71092b",
        "storage_key": "property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsZ-J8xoHK4cRKn-2R4FyRQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_80e55779c033920347b36548",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Honeywell Aerospace FCU",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1300 W Warner Rd #1221, Tempe, AZ 85284, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10485177879527438580&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "honeywell-aerospace-fcu",
      "poi_latitude": "33.3365421",
      "poi_longitude": "-111.9596236",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 480-592-1041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc1-73c2-898f-11b4fe71092b",
        "storage_key": "property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK6R5R9MFK4cR9DgEhLrVgpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "ec_31b36a787159a0ee32875078",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Banner - University Medical Center Phoenix",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1111 E McDowell Rd, Phoenix, AZ 85006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-32c0-70ec-982a-5997d64f43b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-32c0-70ec-982a-5997d64f43b8",
        "storage_key": "property/5697689396183040/019f14fb-32c0-70ec-982a-5997d64f43b8.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.bannerhealth.com/locations/phoenix/banner-university-medical-center-phoenix?y_source=1_MTE5MDczNTMtNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=5784332207521473033&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "banner---university-medical-center-phoenix",
      "poi_latitude": "33.4645644",
      "poi_longitude": "-112.0573664",
      "poi_miles_from_property": "10.5 mi",
      "poi_walking_minutes": "3 hours 53 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 602-839-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-e06d-77c0-a265-c1ba9487ed07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-e06d-77c0-a265-c1ba9487ed07",
        "storage_key": "property/5697689396183040/019d02f1-e06d-77c0-a265-c1ba9487ed07.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJoV6LoQ0SK4cRCSIr_H4TRlA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_7c3ddbc9eef4aa425b790198",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Mayo Clinic Hospital PHX-1",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5777 E Mayo Blvd, Phoenix, AZ 85054, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-32b7-702a-8403-c3c60e8417ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-32b7-702a-8403-c3c60e8417ea",
        "storage_key": "property/5697689396183040/019f14fb-32b7-702a-8403-c3c60e8417ea.webp",
        "width": 707,
        "height": 398
      },
      "poi_business_url": "http://www.mayoclinic.org/patient-visitor-guide/arizona/campus-buildings-maps/mayo-clinic-hospital?mc_id=us&utm_source=yext&utm_medium=l&utm_content=feature&utm_campaign=mayoclinic&geo=national&placementsite=enterprise&invsrc=other&cauid=102372&y_source=1_MzkxODQ3MS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3974166919252800114&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mayo-clinic-hospital-phx-1",
      "poi_latitude": "33.6594309",
      "poi_longitude": "-111.9563162",
      "poi_miles_from_property": "19.4 mi",
      "poi_walking_minutes": "7 hours 17 mins",
      "poi_biking_minutes": "1 hour 52 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 480-342-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-e06d-77c0-a265-c1ba9487ed07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-e06d-77c0-a265-c1ba9487ed07",
        "storage_key": "property/5697689396183040/019d02f1-e06d-77c0-a265-c1ba9487ed07.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJUV5hvjVxK4cRcvIrzMETJzc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_6453ba196cefc761323fb822",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "Tempe City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "31 E 5th St, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14fb-3ece-758d-831a-3ae513fce844.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-3ece-758d-831a-3ae513fce844",
        "storage_key": "property/5697689396183040/019f14fb-3ece-758d-831a-3ae513fce844.webp",
        "width": 1280,
        "height": 766
      },
      "poi_business_url": "http://www.tempe.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16942479900931186008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tempe-city-hall",
      "poi_latitude": "33.4249356",
      "poi_longitude": "-111.9383812",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 480-350-4311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc4-71b0-8ce2-1ae8c05c53ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc4-71b0-8ce2-1ae8c05c53ed",
        "storage_key": "property/5697689396183040/019d02f1-dbc4-71b0-8ce2-1ae8c05c53ed.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFZ40bdgIK4cRWN0ybbTHH-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "ec_ea853fbbea2d1399e2730315",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "poi_name": "State Farm at Marina Heights",
      "poi_type": "Major Employers & Offices",
      "poi_address": "600 E Rio Salado Pkwy, Tempe, AZ 85281, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14f7-dcf0-740e-8907-5198fd8a3ef6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-dcf0-740e-8907-5198fd8a3ef6",
        "storage_key": "property/5697689396183040/019f14f7-dcf0-740e-8907-5198fd8a3ef6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.statefarm.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1601884207670731235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "state-farm-at-marina-heights",
      "poi_latitude": "33.429626",
      "poi_longitude": "-111.9294817",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 855-733-7333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f1-dbc1-73c2-898f-11b4fe71092b",
        "storage_key": "property/5697689396183040/019d02f1-dbc1-73c2-898f-11b4fe71092b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN_x42CAJK4cR46GFITMJOxY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_31767dfbeec47973f7fc2298",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_1f64da0d08d022136218fb5f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_13a74aae561f6586188bfb8d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_97512eca0451302889b55cf4",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_86785586a8fe05a9f7130c3a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_41ef5f51b20ae81c0e438c41",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_acd21491126c1ed88d3d071a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "rating": "5",
      "name": "Zac Chapman",
      "text": "I just want to give a shoutout to Jovi from the maintenance team. I always see him working hard around the property cleaning the hallways, picking up litter, and making sure everything stays looking nice. It’s clear he really cares about keeping the place clean and well maintained. It’s great to see someone consistently putting in the effort to make the community better for everyone",
      "date": "2026-03-05",
      "title": "false"
    },
    {
      "id": "ec_ca1b3cf4de8c6af9bd8ac778",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "rating": "5",
      "name": "Amber Mcnally",
      "text": "Shakeelah Dawan and Gavin Munroe are front office and they're always available to help, very knowledgeable, very kind. This is a beautiful, clean complex. Management and maintenance are on site and will check in with you as well. Any maintenance issues are resolved within 2 days. The maintenance team is kind and takes pride in the buildings.\n\nShakeelah Dawan and Gavin Munroe helped me prepare my information and docs for weeks. Many phone calls made. They were extremely attentive during this time and made sure I got moved in. If you are wanting to move they will make it happen.\n\nMy family loves it here. They have everything you need to entertain family or friends. Work spaces included in lobby. There is a gym, pool, basketball. A shop called Bora Bora just opened up and there's access to it from the inside of your building. It's open late too and serves like breakfast, sweet treats, and sandwiches. It neighbors a tea shop as well. Markets within walking distance. Great parking if you have a car and great transit options otherwise.\n\nI have personally never seen or heard of any issues here.",
      "date": "2026-04-20",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_301bbedee36367b130d5de4b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f14c3-717a-72dc-a248-ab59c3d470fb.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c3-717a-72dc-a248-ab59c3d470fb",
        "storage_key": "property/5697689396183040/019f14c3-717a-72dc-a248-ab59c3d470fb.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "The Access | Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/I-NBxZFcjQs"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa46-0357-7018-b5a2-b52ff6de1479",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-access",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040"
    },
    {
      "lead_collector_id": "0198aa46-03b9-70f8-87dd-46d5c54208ce",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-access",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040"
    },
    {
      "lead_collector_id": "0198aa46-041b-74ea-be6f-f7a39caa5d67",
      "lead_source": "LANDING_PAGE",
      "name": "the-access",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "page_item_url": "dog-park-apartments-tempe-az-969",
      "search_query": "dog park apartments in Tempe AZ",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Tempe, AZ",
      "h2_subtitle": "Looking for dog park apartments in Tempe, AZ? The Access offers a pet-friendly environment with a dedicated dog park and more.",
      "page_copy": "Discover the pet-friendly lifestyle at The Access in Tempe, AZ, your ideal choice among dog park apartments in Tempe, AZ. Our community caters to pet lovers with a fantastic on-site dog park, ensuring your furry friend feels right at home. Located in the vibrant Apache neighborhood, The Access provides a welcoming environment for both pets and their owners.\n\nBeyond the dog park, our amenities enhance your living experience. Dive into relaxation with our resort-style pool or enjoy the tranquility of our garden tub. With available one, two, and three-bedroom layouts, The Access ensures every resident enjoys comfort and convenience. Embrace the ultimate pet-friendly apartment experience in Tempe, AZ at The Access.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and hot tub with surrounding lounge chairs and umbrellas.",
        "public_id": "019f6c10-f377-740b-9525-f799e9f0055c",
        "storage_key": "property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Tempe, AZ",
      "seo_description": "Discover dog park apartments in Tempe, AZ at The Access. Pet-friendly living with resort amenities awaits you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "page_item_url": "luxury-apartments-pool-85281-262",
      "search_query": "luxury apartments with pool in 85281",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in 85281",
      "h2_subtitle": "Searching for luxury apartments with a pool in 85281? The Access in Tempe is your perfect choice with upscale amenities.",
      "page_copy": "Experience top-tier living at The Access, the leading choice for luxury apartments with a pool in 85281. Nestled in Tempe’s lively Apache neighborhood, our community promises a resort-style living with an exceptional pool where you can unwind and rejuvenate. Our available studio to three-bedroom apartment homes are stylishly designed, blending comfort with modern elegance.\n\nAt The Access, you’ll find a selection of superior amenities beyond the stunning pool. Our community features a relaxing fire pit, an inviting coffee bar, and garages for added convenience. Each apartment boasts high-end finishes, including tile backsplashes and spacious garden tubs, ensuring you enjoy luxurious living every day in Tempe, AZ.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and hot tub with surrounding lounge chairs and umbrellas.",
        "public_id": "019f6c10-f377-740b-9525-f799e9f0055c",
        "storage_key": "property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in 85281",
      "seo_description": "Explore luxury apartments with a pool in 85281 at The Access. Discover resort-style amenities and exceptional living in Tempe, AZ.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "page_item_url": "fitness-center-apartments-apache-tempe-102",
      "search_query": "fitness center apartments near Apache Tempe",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments Near Apache, Tempe",
      "h2_subtitle": "Looking for fitness center apartments near Apache, Tempe? Discover a vibrant community at The Access with top-notch amenities.",
      "page_copy": "Elevate your lifestyle at The Access, where fitness center apartments near Apache, Tempe meet modern living. Our community offers a fully-equipped fitness center, perfect for maintaining your wellness routine. Situated in the bustling Apache neighborhood, The Access provides both convenience and style in every apartment layout.\n\nBeyond fitness amenities, our residents enjoy a wealth of features designed to enhance daily life. With options ranging from studio to three-bedroom homes, each apartment includes luxurious touches like tile backsplashes and garden tubs. Plus, indulge in our resort-style pool and utilize our garages and relaxing fire pit. Live in the heart of Tempe with access to everything you need at The Access.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and hot tub with surrounding lounge chairs and umbrellas.",
        "public_id": "019f6c10-f377-740b-9525-f799e9f0055c",
        "storage_key": "property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments Near Apache, Tempe",
      "seo_description": "Find fitness center apartments near Apache, Tempe at The Access. Enjoy modern living with top amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "page_item_url": "coffee-bar-apartment-amenities-maricopa-county-243",
      "search_query": "coffee bar apartment amenities Maricopa County",
      "category": "Amenity",
      "h1_title": "Coffee Bar Apartment Amenities in Maricopa County",
      "h2_subtitle": "Searching for coffee bar apartment amenities in Maricopa County? The Access in Tempe offers the perfect blend of comfort and style.",
      "page_copy": "Discover the ultimate in apartment amenities at The Access, offering an inviting coffee bar as part of our comprehensive experience in Maricopa County. Nestled in Tempe's vibrant Apache neighborhood, our community ensures you enjoy your favorite brews right at home, creating the perfect atmosphere for relaxation or socializing. Whether you're starting your day or winding down, enjoy the coffee bar just steps from your door.\n\nBeyond the tantalizing coffee bar, The Access boasts a wide range of luxurious amenities designed to improve your living experience. Dive into our resort-style pool, take advantage of our pet-friendly environment, or enjoy the warmth of our fire pit. With a choice of studio, one, two, or three-bedroom homes, each crafted with high-end finishes, The Access combines the best of both comfort and convenience in Maricopa County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and hot tub with surrounding lounge chairs and umbrellas.",
        "public_id": "019f6c10-f377-740b-9525-f799e9f0055c",
        "storage_key": "property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Coffee Bar Apartment Amenities, Maricopa County",
      "seo_description": "Explore coffee bar apartment amenities at The Access in Maricopa County. Enjoy luxury living in Tempe with exceptional comforts.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "page_item_url": "apartments-car-charging-stations-tempe-az-979",
      "search_query": "apartments with car charging stations Tempe AZ",
      "category": "Amenity",
      "h1_title": "Apartments with Car Charging Stations in Tempe, AZ",
      "h2_subtitle": "Looking for apartments with car charging stations in Tempe, AZ? Discover The Access, the perfect blend of convenience and modern living.",
      "page_copy": "At The Access, we prioritize convenience and sustainability by offering apartments with car charging stations in Tempe, AZ. Situated in the lively Apache neighborhood, our community is designed to meet the needs of eco-conscious residents while providing a luxurious living environment. Whether you drive an electric vehicle or simply appreciate green initiatives, you'll find The Access accommodating and uniquely suited to modern living.\n\nAlongside our car charging stations, The Access offers a plethora of upscale amenities. Enjoy our resort-style pool, beautifully landscaped outdoor spaces, and inviting fire pit. Our apartment homes, ranging from cozy studios to spacious three-bedroom layouts, feature elegant touches such as tile backsplashes and garden tubs. Experience the best of Tempe living with thoughtful amenities that cater to your lifestyle needs at The Access.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and hot tub with surrounding lounge chairs and umbrellas.",
        "public_id": "019f6c10-f377-740b-9525-f799e9f0055c",
        "storage_key": "property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Car Charging Stations in Tempe, AZ",
      "seo_description": "Discover The Access in Tempe, AZ, apartments with car charging stations and luxury amenities. Enjoy sustainable living in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-tempe-az-194",
      "search_query": "one bedroom apartments tempe az",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Tempe, AZ",
      "h2_subtitle": "Searching for one bedroom apartments in Tempe, AZ? Experience modern living at The Access, with luxury amenities and a prime location.",
      "page_copy": "Experience the perfect balance of comfort and style in our one bedroom apartments in Tempe, AZ. At The Access, each unit is designed to provide optimal living space and high-end features for a truly upgraded lifestyle. Located in the dynamic Apache neighborhood, our community offers not only a prime location but also a myriad of amenities to enhance your everyday experience.\n\nResidents enjoy access to our resort-style pool, modern fitness center, and dog park, making life at The Access both convenient and enjoyable. Each one bedroom apartment is thoughtfully crafted with luxurious details like tile backsplashes and garden tubs. Discover how easy life can be with everything you need at your doorstep in Tempe, AZ, with The Access as your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and hot tub with surrounding lounge chairs and umbrellas.",
        "public_id": "019f6c10-f377-740b-9525-f799e9f0055c",
        "storage_key": "property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Tempe, AZ",
      "seo_description": "Find one bedroom apartments in Tempe, AZ at The Access. Enjoy luxury living with modern amenities and a great location in Apache.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-maricopa-county-410",
      "search_query": "two bedroom apartments maricopa county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Maricopa County",
      "h2_subtitle": "Explore spacious two bedroom apartments in Maricopa County. The Access in Tempe offers luxury living with top-notch amenities.",
      "page_copy": "Discover the best in two bedroom apartments in Maricopa County at The Access. Situated in the vibrant city of Tempe, our community offers spacious layouts perfect for roommates, families, or anyone needing extra space. Each apartment is designed with modern, upscale finishes that set the stage for a luxurious lifestyle.\n\nOur Maricopa County location ensures that everything you need is within reach. Enjoy access to community features like a resort-style pool, a calming outdoor fire pit, and a dog park that caters to your furry friends. Each two bedroom home is crafted with details like tile backsplashes and garden tubs, ensuring comfort and style in every corner. Experience the perfect blend of location, amenities, and quality living at The Access.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and hot tub with surrounding lounge chairs and umbrellas.",
        "public_id": "019f6c10-f377-740b-9525-f799e9f0055c",
        "storage_key": "property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Maricopa County",
      "seo_description": "Discover luxury two bedroom apartments in Maricopa County at The Access, Tempe. Spacious layouts with top amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-near-apache-88",
      "search_query": "three bedroom apartments near apache",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near Apache",
      "h2_subtitle": "Looking for three bedroom apartments near Apache? Discover spacious living at The Access in Tempe, offering unparalleled amenities.",
      "page_copy": "For those seeking spacious three bedroom apartments near Apache, The Access is your ideal destination. Nestled in Tempe, our community provides ample room for families, roommates, or anyone who loves having extra space. Each apartment is thoughtfully designed with modern finishes and high-end amenities, catering to a luxurious lifestyle in the heart of Apache.\n\nAt The Access, residents enjoy a variety of community amenities including a resort-style pool, delightful outdoor spaces, and a resident-favorite coffee bar. Every three bedroom apartment is outfitted with elegant features like tile backsplashes and garden tubs, ensuring a comfortable yet stylish environment. Conveniently located near Apache, The Access offers easy access to local attractions while providing a serene escape from the hustle and bustle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and hot tub with surrounding lounge chairs and umbrellas.",
        "public_id": "019f6c10-f377-740b-9525-f799e9f0055c",
        "storage_key": "property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near Apache",
      "seo_description": "Find spacious three bedroom apartments near Apache at The Access in Tempe. Enjoy luxury amenities and modern living in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "page_item_url": "studio-apartments-85281-806",
      "search_query": "studio apartments 85281",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in 85281",
      "h2_subtitle": "Discover studio apartments in the 85281 area. The Access offers stylish and modern living spaces in the heart of Tempe.",
      "page_copy": "For those seeking urban convenience and modern comfort, our studio apartments in 85281 are the perfect fit. Located at The Access in Tempe, these studios are designed with smart space management and luxury finishes, making them ideal for anyone who values both style and functionality. Situated in the lively 85281 area, you'll have the city at your fingertips.\n\nEnjoy a vibrant community environment with access to a range of amenities such as a resort-style pool and a stylish coffee bar. Each studio is equipped with contemporary features including tile backsplashes and garden tubs, providing a chic yet comfortable living experience. The Access offers the perfect combination of location and lifestyle for those looking to live in the heart of Tempe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and hot tub with surrounding lounge chairs and umbrellas.",
        "public_id": "019f6c10-f377-740b-9525-f799e9f0055c",
        "storage_key": "property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in 85281",
      "seo_description": "Explore modern studio apartments in 85281 at The Access, Tempe. Enjoy luxury amenities and contemporary living in a vibrant location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "page_item_url": "apartments-near-arizona-state-university-tempe-418",
      "search_query": "apartments near arizona state university tempe",
      "category": "School",
      "h1_title": "Apartments Near Arizona State University Tempe",
      "h2_subtitle": "Find ideal apartments near Arizona State University Tempe. The Access offers contemporary living just minutes from campus.",
      "page_copy": "Looking for apartments near Arizona State University Tempe? The Access provides the perfect location just minutes from campus. Ideal for students, faculty, or anyone wanting easy proximity to ASU, our community in Tempe offers a range of living options from cozy studios to expansive three-bedroom layouts. Each apartment is designed with style and convenience in mind, making it a top choice for university living.\n\nBeyond location, The Access elevates your living experience with exceptional community amenities like a resort-style pool, outdoor fire pit, and serene green spaces. Each apartment boasts upscale features such as tile backsplashes and garden tubs, creating a comfortable and modern living environment. Experience the best in student living with all the comforts and conveniences of a premium apartment community near ASU.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and hot tub with surrounding lounge chairs and umbrellas.",
        "public_id": "019f6c10-f377-740b-9525-f799e9f0055c",
        "storage_key": "property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Arizona State University Tempe",
      "seo_description": "Discover contemporary apartments near Arizona State University Tempe at The Access. Enjoy proximity to campus with luxurious amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "page_item_url": "apartment-rentals-close-to-mesa-community-college-584",
      "search_query": "apartment rentals close to mesa community college",
      "category": "School",
      "h1_title": "Apartment Rentals Close to Mesa Community College",
      "h2_subtitle": "Explore apartment rentals close to Mesa Community College. The Access in Tempe offers modern living with easy access to MCC.",
      "page_copy": "If you're searching for apartment rentals close to Mesa Community College, consider The Access in Tempe as your next home. Just a short drive from MCC, our community offers the perfect blend of convenience and comfort for students, faculty, and staff. Choose from a variety of floor plans, including studios and three-bedroom units, all featuring modern design and premium finishes.\n\nAt The Access, residents enjoy a range of amenities that enhance their living experience, including a resort-style pool, a dedicated dog park, and beautifully landscaped outdoor spaces. Each apartment is equipped with stylish touches like tile backsplashes and garden tubs. Positioned conveniently near MCC, The Access provides easy access to academic resources while offering a serene and appealing retreat from campus life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and hot tub with surrounding lounge chairs and umbrellas.",
        "public_id": "019f6c10-f377-740b-9525-f799e9f0055c",
        "storage_key": "property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Rentals Close to Mesa Community College",
      "seo_description": "Find modern apartment rentals close to Mesa Community College at The Access. Enjoy easy access to MCC with resort-style amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "page_item_url": "affordable-living-by-gateway-community-college-740",
      "search_query": "affordable living by gateway community college washington campus",
      "category": "School",
      "h1_title": "Affordable Living by Gateway Community College",
      "h2_subtitle": "Discover affordable living by Gateway Community College Washington Campus. The Access provides budget-friendly, modern homes.",
      "page_copy": "Looking for affordable living by Gateway Community College Washington Campus? The Access in Tempe offers budget-conscious options without compromising on quality or style. Perfectly situated to provide convenient access to the Gateway Community College Washington Campus, our community delivers a cost-effective yet modern living experience for students and staff alike.\n\nWith a selection of thoughtfully designed apartments and a plethora of amenities such as a resort-style pool and a coffee bar, you'll enjoy a comfortable lifestyle at an affordable price. Each apartment features modern finishes like tile backsplashes and garden tubs, ensuring you have a stylish and cozy home base. The Access enhances your living with affordability and convenience at its core, making it a prime choice for anyone studying or working near the Washington Campus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and hot tub with surrounding lounge chairs and umbrellas.",
        "public_id": "019f6c10-f377-740b-9525-f799e9f0055c",
        "storage_key": "property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Affordable Living by Gateway Community College",
      "seo_description": "Enjoy affordable living near Gateway Community College Washington Campus at The Access, Tempe. Modern homes with exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "page_item_url": "apartments-near-banner-desert-medical-center-tempe-98",
      "search_query": "apartments near Banner Desert Medical Center Tempe",
      "category": "Hospital",
      "h1_title": "Apartments Near Banner Desert Medical Center",
      "h2_subtitle": "Find apartments near Banner Desert Medical Center in Tempe. The Access offers convenient living with premium features.",
      "page_copy": "For those seeking apartments near Banner Desert Medical Center in Tempe, The Access offers a perfect home base. With a short commute to the medical center, our community provides easy access to work while ensuring a comfortable and enjoyable living environment. Choose from stylish studios to spacious three-bedroom apartments, all thoughtfully designed to enhance your lifestyle.\n\nResidents at The Access enjoy a range of exceptional amenities, including a resort-style pool, pet-friendly spaces such as a dog park, and elegant outdoor areas complete with a fire pit. Inside, each apartment boasts high-end features like tile backsplashes and garden tubs. Located in Tempe, The Access not only offers proximity to Banner Desert Medical Center but also provides a superior apartment living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and hot tub with surrounding lounge chairs and umbrellas.",
        "public_id": "019f6c10-f377-740b-9525-f799e9f0055c",
        "storage_key": "property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Banner Desert Medical Center",
      "seo_description": "Explore The Access, offering apartments near Banner Desert Medical Center in Tempe. Experience easy living with exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "page_item_url": "apartments-close-to-honorhealth-scottsdale-osborn-2",
      "search_query": "apartments close to HonorHealth Scottsdale Osborn Medical Center AZ",
      "category": "Hospital",
      "h1_title": "Apartments Close to HonorHealth Osborn Medical",
      "h2_subtitle": "Discover apartments close to HonorHealth Scottsdale Osborn Medical Center AZ. The Access offers convenient and stylish living options.",
      "page_copy": "Searching for apartments close to HonorHealth Scottsdale Osborn Medical Center in AZ? Look no further than The Access in Tempe. Our community is ideally located to offer minimal commuting time to HonorHealth Scottsdale Osborn while providing a comfortable and upscale living environment. Choose from a variety of floor plans, including cozy studios and expansive three-bedroom units, each designed with modern living in mind.\n\nThe Access offers an array of premium amenities such as a resort-style pool, a serene garden tub setup, and spacious outdoor areas perfect for relaxation. We pride ourselves on delivering a stylish living experience with features like tile backsplashes that add a touch of elegance. With its convenient location and luxurious offerings, The Access is the perfect residence for healthcare professionals seeking proximity to HonorHealth Scottsdale Osborn Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and hot tub with surrounding lounge chairs and umbrellas.",
        "public_id": "019f6c10-f377-740b-9525-f799e9f0055c",
        "storage_key": "property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to HonorHealth Osborn Medical",
      "seo_description": "Find convenient and stylish apartments close to HonorHealth Scottsdale Osborn Medical Center AZ at The Access, offering premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "page_item_url": "apartments-near-desert-botanical-garden-tempe-649",
      "search_query": "apartments near Desert Botanical Garden Tempe",
      "category": "Park",
      "h1_title": "Apartments Near Desert Botanical Garden Tempe",
      "h2_subtitle": "Explore apartments near Desert Botanical Garden in Tempe. Enjoy vibrant living at The Access with top-notch amenities.",
      "page_copy": "Experience the charm of living near the Desert Botanical Garden in Tempe by choosing The Access for your next apartment. Our prime location offers easy access to the stunning landscapes and trails of the Desert Botanical Garden, perfect for nature enthusiasts who appreciate the beauty of the Sonoran Desert. Whether you prefer a cozy studio or a spacious three-bedroom, our selection of apartments is sure to suit your lifestyle needs.\n\nAt The Access, you'll find a host of amenities designed to enhance your living experience, including a refreshing resort-style pool, pet-friendly spaces, and a social outdoor fire pit area. With features like tile backsplashes and garden tubs, our apartments provide comfort and luxury. Immerse yourself in a vibrant community that places you just moments away from the natural wonders of the Desert Botanical Garden.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and hot tub with surrounding lounge chairs and umbrellas.",
        "public_id": "019f6c10-f377-740b-9525-f799e9f0055c",
        "storage_key": "property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Desert Botanical Garden Tempe",
      "seo_description": "Live near Desert Botanical Garden in Tempe. Find modern apartments with amenities at The Access, a perfect blend of nature and city life.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "page_item_url": "apartments-close-to-papago-park-maricopa-county-363",
      "search_query": "apartments close to Papago Park Maricopa County",
      "category": "Park",
      "h1_title": "Apartments Close to Papago Park Maricopa",
      "h2_subtitle": "Find apartments close to Papago Park in Maricopa County. The Access offers an ideal blend of convenience and comfort.",
      "page_copy": "Looking for apartments close to Papago Park in Maricopa County? The Access in Tempe is an ideal choice, perfectly situated to enjoy the scenic beauty and recreational opportunities of Papago Park. Our community offers a range of living options from studios to expansive three-bedroom apartments, all designed for a comfortable lifestyle.\n\nResidents at The Access can enjoy luxury amenities like a resort-style pool and cozy outdoor spaces perfect for relaxation near a fire pit. Our pet-friendly philosophy includes a dog park to keep your furry friends happy. Elegant finishes such as tile backsplashes and garden tubs complete the upscale living experience, providing a peaceful retreat just minutes from Papago Park's natural splendor.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and hot tub with surrounding lounge chairs and umbrellas.",
        "public_id": "019f6c10-f377-740b-9525-f799e9f0055c",
        "storage_key": "property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Papago Park Maricopa",
      "seo_description": "Discover The Access in Tempe for apartments close to Papago Park, Maricopa County, offering convenience and top-tier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "page_item_url": "apartments-near-tempe-beach-park-85281-305",
      "search_query": "apartments near Tempe Beach Park 85281",
      "category": "Park",
      "h1_title": "Apartments Near Tempe Beach Park 85281",
      "h2_subtitle": "Discover apartments near Tempe Beach Park in the 85281 area. The Access offers prime living with exceptional amenities.",
      "page_copy": "If you're searching for apartments near Tempe Beach Park in the 85281 area, The Access is your gateway to a vibrant lifestyle. Located in the heart of Tempe, this community is perfect for those who love staying active and enjoying the outdoors, with Tempe Beach Park just a short distance away. Whether you need a studio or a sprawling three-bedroom, our apartments are tailored to fit your lifestyle.\n\nThe Access is loaded with premium amenities designed to enhance your daily living, from a refreshing resort-style pool to a garden tub in select units for ultimate relaxation. Pet lovers can enjoy our dedicated dog park, while social butterflies can mingle at the fire pit or at our coffee bar. Embrace the convenience and style of living near Tempe Beach Park, making The Access your ideal new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and hot tub with surrounding lounge chairs and umbrellas.",
        "public_id": "019f6c10-f377-740b-9525-f799e9f0055c",
        "storage_key": "property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tempe Beach Park 85281",
      "seo_description": "Live close to Tempe Beach Park in 85281 at The Access. Enjoy luxury amenities in a prime location for active lifestyles.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "page_item_url": "apartments-near-phoenix-sky-harbor-airport-809",
      "search_query": "apartments near Phoenix Sky Harbor International Airport",
      "category": "Transit",
      "h1_title": "Apartments Near Phoenix Sky Harbor Airport",
      "h2_subtitle": "Discover apartments near Phoenix Sky Harbor International Airport. The Access offers superb living just minutes from the airport.",
      "page_copy": "Enjoy the convenience of living near Phoenix Sky Harbor International Airport by choosing The Access as your new home. Located in Tempe, our property provides easy access to major transportation hubs, making it an excellent choice for frequent travelers. Whether you prefer a studio or need more space in a three-bedroom apartment, we offer various layouts to accommodate your needs.\n\nResidents can indulge in a variety of amenities that make life more enjoyable and stress-free. Our resort-style pool provides a relaxing oasis, while the pet-friendly policy ensures there's room for your furry friends. Meet new neighbors around the outdoor fire pit or enjoy a cup of coffee at the on-site coffee bar. Embrace comfortable living with easy airport access by choosing The Access, perfectly situated near Phoenix Sky Harbor International Airport.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and hot tub with surrounding lounge chairs and umbrellas.",
        "public_id": "019f6c10-f377-740b-9525-f799e9f0055c",
        "storage_key": "property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Phoenix Sky Harbor Airport",
      "seo_description": "Choose The Access in Tempe for apartments near Phoenix Sky Harbor Airport. Enjoy amenities with easy airport access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "page_item_url": "apartments-close-to-44th-st-washington-tempe-316",
      "search_query": "apartments close to 44th St/Washington Tempe",
      "category": "Transit",
      "h1_title": "Apartments Close to 44th St/Washington",
      "h2_subtitle": "Find apartments close to 44th St/Washington in Tempe. Enjoy the convenience and comfort at The Access.",
      "page_copy": "Looking for apartments close to 44th St/Washington in Tempe? The Access offers the perfect blend of location and luxury. Situated in the heart of Tempe, our community provides quick access to public transit and major roadways, making commuting and exploration effortless. Choose from our diverse living options, ranging from cozy studios to expansive three-bedroom layouts, all designed with your comfort in mind.\n\nAt The Access, high-end amenities are standard, including a resort-style pool for relaxation and a fireside lounge for social gatherings. Our pet-friendly environment includes an on-site dog park, ensuring fun for your four-legged family members. Every apartment features elegant touches like tile backsplashes and garden tubs, transforming your living space into a personal retreat. Make The Access your home and enjoy the convenience of being close to 44th St/Washington.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and hot tub with surrounding lounge chairs and umbrellas.",
        "public_id": "019f6c10-f377-740b-9525-f799e9f0055c",
        "storage_key": "property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to 44th St/Washington Tempe",
      "seo_description": "Discover The Access for apartments close to 44th St/Washington in Tempe. Enjoy luxury amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "page_item_url": "apartments-near-terminal-3-station-az-548",
      "search_query": "apartments near Terminal 3 Station AZ",
      "category": "Transit",
      "h1_title": "Apartments Near Terminal 3 Station AZ",
      "h2_subtitle": "Explore apartments near Terminal 3 Station AZ. The Access provides easy transit options and luxurious amenities.",
      "page_copy": "Discover the ease of urban living with apartments near Terminal 3 Station AZ at The Access in Tempe. Perfectly positioned to give you quick access to the area's best transit options, our community makes it easy to travel without the hassle. Whether you prefer a studio or a spacious three-bedroom setup, you'll find the perfect space that suits your lifestyle needs.\n\nLiving at The Access means enjoying a wealth of on-site amenities. Dive into relaxation with our resort-style pool or unwind at the coffee bar. Our pet-friendly environment includes a dedicated dog park, so your pets can enjoy the community too. Modern features like tile backsplashes and garden tubs add a touch of luxury, while our fire pit creates the perfect ambiance for social evenings. Choose The Access today and experience unparalleled convenience near Terminal 3 Station AZ.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and hot tub with surrounding lounge chairs and umbrellas.",
        "public_id": "019f6c10-f377-740b-9525-f799e9f0055c",
        "storage_key": "property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Terminal 3 Station AZ",
      "seo_description": "Find your ideal home at The Access, near Terminal 3 Station AZ, and enjoy luxurious amenities with convenient transit access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "page_item_url": "apartments-close-to-44th-st-station-maricopa-609",
      "search_query": "apartments close to 44th St Station Maricopa County",
      "category": "Transit",
      "h1_title": "Apartments Close to 44th St Station",
      "h2_subtitle": "Discover apartments close to 44th St Station in Maricopa County. Enjoy convenience and comfort at The Access.",
      "page_copy": "Looking for apartments close to 44th St Station in Maricopa County? The Access in Tempe offers the perfect location with direct transit access, ideal for daily commuters and urban explorers. Our community is designed to accommodate various lifestyles with modern studio, one, two, and three-bedroom apartment options.\n\nEnjoy a plethora of amenities right at your doorstep, including a resort-style pool for ultimate relaxation and a welcoming coffee bar to kickstart your mornings. Our pet-friendly spaces feature an on-site dog park, ensuring your pets feel at home too. Luxurious touches such as elegant tile backsplashes and garden tubs enhance your apartment living experience. Choose The Access for a convenient and comfortable lifestyle near 44th St Station.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and hot tub with surrounding lounge chairs and umbrellas.",
        "public_id": "019f6c10-f377-740b-9525-f799e9f0055c",
        "storage_key": "property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to 44th St Station",
      "seo_description": "Choose The Access for apartments close to 44th St Station in Maricopa County. Enjoy luxury living with easy transit access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5697689396183040",
      "source": "custom",
      "page_item_url": "apartments-near-veterans-way-college-ave-apache-tempe-680",
      "search_query": "apartments near Veterans Way/College Ave Apache Tempe",
      "category": "Transit",
      "h1_title": "Apartments Near Veterans Way/College Ave Tempe",
      "h2_subtitle": "Explore apartments near Veterans Way/College Ave in Apache, Tempe. Discover comfort and convenience at The Access.",
      "page_copy": "If you're searching for apartments near Veterans Way/College Ave in Apache, Tempe, The Access is your ideal destination. Centrally located, our community offers seamless connectivity to the surrounding areas and all the conveniences that urban living in Tempe provides. Choose from a variety of apartment layouts, from cozy studios to generous three-bedroom floor plans, each designed to cater to your unique lifestyle.\n\nThe Access features exceptional amenities such as a resort-style pool perfect for unwinding after a long day, a state-of-the-art dog park, and a cozy coffee bar to enjoy your morning brew. Each apartment boasts stunning details, including tile backsplashes and indulgent garden tubs, creating a luxurious oasis you’ll love coming home to. Experience the best of Tempe living at The Access, where you're close to the vibrant vibes of Veterans Way/College Ave.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and hot tub with surrounding lounge chairs and umbrellas.",
        "public_id": "019f6c10-f377-740b-9525-f799e9f0055c",
        "storage_key": "property/5697689396183040/019f6c10-f377-740b-9525-f799e9f0055c.webp",
        "width": 1127,
        "height": 844
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Veterans Way/College Ave Tempe",
      "seo_description": "Discover The Access for apartments near Veterans Way/College Ave Apache Tempe, featuring luxury amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2291"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2505043595"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a4b\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a4b\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4994510"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-P4KNP89"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8384504408"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "abc3911f1e06d96a"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/m9pzym64vk1"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/0bd45f30-ba45-4776-b1b7-a6ef1a265da2"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "602-557-2983"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Imp2YzVZelpjd2NLbVZYVGJuWmtDNGc9PSIsInZhbHVlIjoic1lnMUsrZmI2NDl1UEpEYWk0S29Zdz09IiwibWFjIjoiM2U2YjEzZDU0M2RkMzdiMDllMTdiZmY3N2U4M2IzNjJmYmEzZmQ3YzI4NDgyZTBiMzY2N2IxNDNhM2VjOWU2YiJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2291",
  "custom_repli_id": "2505043595",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a4b\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a4b\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4994510",
  "custom_google_gtm_id": "GTM-P4KNP89",
  "custom_rollout_phase": "2",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8384504408",
  "custom_knock_community_id": "abc3911f1e06d96a",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/m9pzym64vk1",
  "custom_self_guided_tour_url": "https://selftournow.com/property/0bd45f30-ba45-4776-b1b7-a6ef1a265da2",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "602-557-2983",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Imp2YzVZelpjd2NLbVZYVGJuWmtDNGc9PSIsInZhbHVlIjoic1lnMUsrZmI2NDl1UEpEYWk0S29Zdz09IiwibWFjIjoiM2U2YjEzZDU0M2RkMzdiMDllMTdiZmY3N2U4M2IzNjJmYmEzZmQ3YzI4NDgyZTBiMzY2N2IxNDNhM2VjOWU2YiJ9",
  "custom_household_income_qualification_multiplier": "3"
};

export const generatedAt = '2026-10-09T16:36:34.321Z';
